(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.7
  //     https://underscorejs.org
  //     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.7';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global) ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || (type === 'object' && !!obj);
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  // Also, there are cases where an application can override the native
  // `DataView` object, in cases like that we can't use the constructor
  // safely and should just rely on alternate `DataView` checks
  var hasDataViewBug = (
        supportsDataView && (!/\[native code\]/.test(String(DataView)) || hasObjectTag(new DataView(new ArrayBuffer(8))))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  // Also, in cases where the native `DataView` is
  // overridden we can't rely on the tag itself.
  function alternateIsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasDataViewBug ? alternateIsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key] === true; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasDataViewBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = toArray(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = (array && max(array, getLength).length) || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));
//# sourceMappingURL=underscore-umd.js.map
;
//     Backbone.js 1.6.0

//     (c) 2010-2024 Jeremy Ashkenas and DocumentCloud
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global;

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'jquery', 'exports'], function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    });

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, root.jQuery || root.Zepto || root.ender || root.$);
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.6.0';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // A private global variable to share between listeners and listenees.
  var _listening;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    this._events = eventsApi(onApi, this._events || {}, name, callback, {
      context: context,
      ctx: this,
      listening: _listening
    });

    if (_listening) {
      var listeners = this._listeners || (this._listeners = {});
      listeners[_listening.id] = _listening;
      // Allow the listening to use a counter, instead of tracking
      // callbacks for library interop
      _listening.interop = false;
    }

    return this;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = _listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      this._listenId || (this._listenId = _.uniqueId('l'));
      listening = _listening = listeningTo[id] = new Listening(this, obj);
    }

    // Bind callbacks on obj.
    var error = tryCatchOn(obj, name, callback, this);
    _listening = void 0;

    if (error) throw error;
    // If the target obj is not Backbone.Events, track events manually.
    if (listening.interop) listening.on(name, callback);

    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // An try-catch guarded #on function, to prevent poisoning the global
  // `_listening` variable.
  var tryCatchOn = function(obj, name, callback, context) {
    try {
      obj.on(name, callback, context);
    } catch (e) {
      return e;
    }
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });

    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
      if (listening.interop) listening.off(name, callback);
    }
    if (_.isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var context = options.context, listeners = options.listeners;
    var i = 0, names;

    // Delete all event listeners and "drop" events.
    if (!name && !context && !callback) {
      for (names = _.keys(listeners); i < names.length; i++) {
        listeners[names[i]].cleanup();
      }
      return;
    }

    names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Find any remaining events.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          var listening = handler.listening;
          if (listening) listening.off(name, callback);
        }
      }

      // Replace events if there are any remaining.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }

    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // A listening class that tracks and cleans up memory bindings
  // when all callbacks have been offed.
  var Listening = function(listener, obj) {
    this.id = listener._listenId;
    this.listener = listener;
    this.obj = obj;
    this.interop = true;
    this.count = 0;
    this._events = void 0;
  };

  Listening.prototype.on = Events.on;

  // Offs a callback (or several).
  // Uses an optimized counter if the listenee uses Backbone.Events.
  // Otherwise, falls back to manual tracking to support events
  // library interop.
  Listening.prototype.off = function(name, callback) {
    var cleanup;
    if (this.interop) {
      this._events = eventsApi(offApi, this._events, name, callback, {
        context: void 0,
        listeners: void 0
      });
      cleanup = !this._events;
    } else {
      this.count--;
      cleanup = this.count === 0;
    }
    if (cleanup) this.cleanup();
  };

  // Cleans up memory bindings between the listener and the listenee.
  Listening.prototype.cleanup = function() {
    delete this.listener._listeningTo[this.obj._listenId];
    if (!this.interop) delete this.obj._listeners[this.id];
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.preinitialize.apply(this, arguments);
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');

    // Just _.defaults would work fine, but the additional _.extends
    // is in there for historical reasons. See #3843.
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);

    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the Model.
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) {
        var prevId = this.id;
        this.id = this.get(this.idAttribute);
        this.trigger('changeId', this, prevId, options);
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      var hasChanged;
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
        hasChanged = true;
      }
      return hasChanged ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    this.preinitialize.apply(this, arguments);
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,


    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the Collection.
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj, obj.idAttribute)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = comparator.bind(this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) {
          m.off('error', collection._forwardPristineError, collection);
          collection.add(m, callbackOpts);
        }
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      // In case of wait:true, our collection is not listening to any
      // of the model's events yet, so it will not forward the error
      // event. In this special case, we need to listen for it
      // separately and handle the event just once.
      // (The reason we don't need to do this for the sync event is
      // in the success handler above: we add the model first, which
      // causes the collection to listen, and then invoke the callback
      // that triggers the event.)
      if (wait) {
        model.once('error', this._forwardPristineError, this);
      }
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs, idAttribute) {
      return attrs[idAttribute || this.model.prototype.idAttribute || 'id'];
    },

    // Get an iterator of all models in this collection.
    values: function() {
      return new CollectionIterator(this, ITERATOR_VALUES);
    },

    // Get an iterator of all model IDs in this collection.
    keys: function() {
      return new CollectionIterator(this, ITERATOR_KEYS);
    },

    // Get an iterator of all [ID, model] tuples in this collection.
    entries: function() {
      return new CollectionIterator(this, ITERATOR_KEYSVALUES);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;

      var model;
      if (this.model.prototype) {
        model = new this.model(attrs, options);
      } else {
        // ES class methods didn't have prototype
        model = this.model(attrs, options);
      }

      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes, model.idAttribute);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      if (models.length > 0 && !options.silent) delete options.index;
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes, model.idAttribute);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes, model.idAttribute);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'changeId') {
          var prevId = this.modelId(model.previousAttributes(), model.idAttribute);
          var id = this.modelId(model.attributes, model.idAttribute);
          if (prevId != null) delete this._byId[prevId];
          if (id != null) this._byId[id] = model;
        }
      }
      this.trigger.apply(this, arguments);
    },

    // Internal callback method used in `create`. It serves as a
    // stand-in for the `_onModelEvent` method, which is not yet bound
    // during the `wait` period of the `create` call. We still want to
    // forward any `'error'` event at the end of the `wait` period,
    // hence a customized callback.
    _forwardPristineError: function(model, collection, options) {
      // Prevent double forward if the model was already in the
      // collection before the call to `create`.
      if (this.has(model)) return;
      this._onModelEvent('error', model, collection, options);
    }
  });

  // Defining an @@iterator method implements JavaScript's Iterable protocol.
  // In modern ES2015 browsers, this value is found at Symbol.iterator.
  /* global Symbol */
  var $$iterator = typeof Symbol === 'function' && Symbol.iterator;
  if ($$iterator) {
    Collection.prototype[$$iterator] = Collection.prototype.values;
  }

  // CollectionIterator
  // ------------------

  // A CollectionIterator implements JavaScript's Iterator protocol, allowing the
  // use of `for of` loops in modern browsers and interoperation between
  // Backbone.Collection and other JavaScript functions and third-party libraries
  // which can operate on Iterables.
  var CollectionIterator = function(collection, kind) {
    this._collection = collection;
    this._kind = kind;
    this._index = 0;
  };

  // This "enum" defines the three possible kinds of values which can be emitted
  // by a CollectionIterator that correspond to the values(), keys() and entries()
  // methods on Collection, respectively.
  var ITERATOR_VALUES = 1;
  var ITERATOR_KEYS = 2;
  var ITERATOR_KEYSVALUES = 3;

  // All Iterators should themselves be Iterable.
  if ($$iterator) {
    CollectionIterator.prototype[$$iterator] = function() {
      return this;
    };
  }

  CollectionIterator.prototype.next = function() {
    if (this._collection) {

      // Only continue iterating if the iterated collection is long enough.
      if (this._index < this._collection.length) {
        var model = this._collection.at(this._index);
        this._index++;

        // Construct a value depending on what kind of values should be iterated.
        var value;
        if (this._kind === ITERATOR_VALUES) {
          value = model;
        } else {
          var id = this._collection.modelId(model.attributes, model.idAttribute);
          if (this._kind === ITERATOR_KEYS) {
            value = id;
          } else { // ITERATOR_KEYSVALUES
            value = [id, model];
          }
        }
        return {value: value, done: false};
      }

      // Once exhausted, remove the reference to the collection so future
      // calls to the next method always return done.
      this._collection = void 0;
    }

    return {value: void 0, done: true};
  };

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this.preinitialize.apply(this, arguments);
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the View
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], method.bind(this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(base, length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return base[method](this[attribute]);
      };
      case 2: return function(value) {
        return base[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return base[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return base[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return base[method].apply(base, args);
      };
    }
  };

  var addUnderscoreMethods = function(Class, base, methods, attribute) {
    _.each(methods, function(length, method) {
      if (base[method]) Class.prototype[method] = addMethod(base, length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
    foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
    select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
    contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
    head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
    without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
    isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
    sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};


  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
    omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Collection#models`.

  _.each([
    [Collection, collectionMethods, 'models'],
    [Model, modelMethods, 'attributes']
  ], function(config) {
    var Base = config[0],
        methods = config[1],
        attribute = config[2];

    Base.mixin = function(obj) {
      var mappings = _.reduce(_.functions(obj), function(memo, name) {
        memo[name] = 0;
        return memo;
      }, {});
      addUnderscoreMethods(Base, obj, mappings, attribute);
    };

    addUnderscoreMethods(Base, _, methods, attribute);
  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    this.preinitialize.apply(this, arguments);
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // preinitialize is an empty function by default. You can override it with a function
    // or object.  preinitialize will run before any instantiation logic is run in the Router.
    preinitialize: function(){},

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
      .replace(optionalParam, '(?:$1)?')
      .replace(namedParam, function(match, optional) {
        return optional ? match : '([^/?]+)';
      })
      .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = this.checkUrl.bind(this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._trailingSlash   = this.options.trailingSlash;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) {
        if (!this.matchRoot()) return this.notfound();
        return false;
      }
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return this.notfound();
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      }) || this.notfound();
    },

    // When no route could be matched, this method is called internally to
    // trigger the `'notfound'` event. It returns `false` so that it can be used
    // in tail position.
    notfound: function() {
      this.trigger('notfound');
      return false;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Strip trailing slash on the root unless _trailingSlash is true
      var rootPath = this.root;
      if (!this._trailingSlash && (fragment === '' || fragment.charAt(0) === '?')) {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the fragment of the query and hash for matching.
      fragment = fragment.replace(pathStripper, '');

      // Decode for matching.
      var decodedFragment = this.decodeFragment(fragment);

      if (this.fragment === decodedFragment) return;
      this.fragment = decodedFragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  // Provide useful information when things go wrong. This method is not meant
  // to be used directly; it merely provides the necessary introspection for the
  // external `debugInfo` function.
  Backbone._debug = function() {
    return {root: root, _: _};
  };

  return Backbone;
});
;
/**
 * date.format.js from https://github.com/jacwright/date.format
 * For some reason npm is not letting me get this via git.
 */
(function() {
	// Checking for locale month and day names
	if(typeof locale !== 'undefined'){
		Date.shortMonths = locale.shortMonths;
		Date.longMonths = locale.longMonths;
		Date.shortDays = locale.shortDays;
		Date.longDays = locale.longDays;
	}else{
		Date.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		Date.longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		Date.shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		Date.longDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	}

    // Defining patterns
    var replaceChars = {
        // Day
        d: function() { var d = this.getDate(); return (d < 10 ? '0' : '') + d; },
        D: function() { return Date.shortDays[this.getDay()]; },
        j: function() { return this.getDate(); },
        l: function() { return Date.longDays[this.getDay()]; },
        N: function() { var N = this.getDay(); return (N == 0 ? 7 : N); },
        S: function() { var S = this.getDate(); return (S % 10 == 1 && S != 11 ? 'st' : (S % 10 == 2 && S != 12 ? 'nd' : (S % 10 == 3 && S != 13 ? 'rd' : 'th'))); },
        w: function() { return this.getDay(); },
        z: function() { var d = new Date(this.getFullYear(),0,1); return Math.ceil((this - d) / 86400000); },
        // Week
        W: function() {
            var target = new Date(this.valueOf());
            var dayNr = (this.getDay() + 6) % 7;
            target.setDate(target.getDate() - dayNr + 3);
            var firstThursday = target.valueOf();
            target.setMonth(0, 1);
            if (target.getDay() !== 4) {
                target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
            }
            var retVal = 1 + Math.ceil((firstThursday - target) / 604800000);

            return (retVal < 10 ? '0' + retVal : retVal);
        },
        // Month
        F: function() { return Date.longMonths[this.getMonth()]; },
        m: function() { var m = this.getMonth(); return (m < 9 ? '0' : '') + (m + 1); },
        M: function() { return Date.shortMonths[this.getMonth()]; },
        n: function() { return this.getMonth() + 1; },
        t: function() {
            var year = this.getFullYear(), nextMonth = this.getMonth() + 1;
            if (nextMonth === 12) {
                year = year++;
                nextMonth = 0;
            }
            return new Date(year, nextMonth, 0).getDate();
        },
        // Year
        L: function() { var L = this.getFullYear(); return (L % 400 == 0 || (L % 100 != 0 && L % 4 == 0)); },
        o: function() { var d  = new Date(this.valueOf());  d.setDate(d.getDate() - ((this.getDay() + 6) % 7) + 3); return d.getFullYear();},
        Y: function() { return this.getFullYear(); },
        y: function() { return ('' + this.getFullYear()).substring(2); },
        // Time
        a: function() { return this.getHours() < 12 ? 'am' : 'pm'; },
        A: function() { return this.getHours() < 12 ? 'AM' : 'PM'; },
        B: function() { return Math.floor((((this.getUTCHours() + 1) % 24) + this.getUTCMinutes() / 60 + this.getUTCSeconds() / 3600) * 1000 / 24); },
        g: function() { return this.getHours() % 12 || 12; },
        G: function() { return this.getHours(); },
        h: function() { var h = this.getHours(); return ((h % 12 || 12) < 10 ? '0' : '') + (h % 12 || 12); },
        H: function() { var H = this.getHours(); return (H < 10 ? '0' : '') + H; },
        i: function() { var i = this.getMinutes(); return (i < 10 ? '0' : '') + i; },
        s: function() { var s = this.getSeconds(); return (s < 10 ? '0' : '') + s; },
        v: function() { var v = this.getMilliseconds(); return (v < 10 ? '00' : (v < 100 ? '0' : '')) + v; },
        // Timezone
        e: function() { return Intl.DateTimeFormat().resolvedOptions().timeZone; },
        I: function() {
            var DST = null;
                for (var i = 0; i < 12; ++i) {
                        var d = new Date(this.getFullYear(), i, 1);
                        var offset = d.getTimezoneOffset();

                        if (DST === null) DST = offset;
                        else if (offset < DST) { DST = offset; break; }                     else if (offset > DST) break;
                }
                return (this.getTimezoneOffset() == DST) | 0;
            },
        O: function() { var O = this.getTimezoneOffset(); return (-O < 0 ? '-' : '+') + (Math.abs(O / 60) < 10 ? '0' : '') + Math.floor(Math.abs(O / 60)) + (Math.abs(O % 60) == 0 ? '00' : ((Math.abs(O % 60) < 10 ? '0' : '')) + (Math.abs(O % 60))); },
        P: function() { var P = this.getTimezoneOffset(); return (-P < 0 ? '-' : '+') + (Math.abs(P / 60) < 10 ? '0' : '') + Math.floor(Math.abs(P / 60)) + ':' + (Math.abs(P % 60) == 0 ? '00' : ((Math.abs(P % 60) < 10 ? '0' : '')) + (Math.abs(P % 60))); },
		T: function() { var tz = this.toLocaleTimeString(navigator.language,{timeZoneName:'short'}).split(' '); return tz[tz.length - 1]; },
        Z: function() { return -this.getTimezoneOffset() * 60; },
        // Full Date/Time
        c: function() { return this.format("Y-m-d\\TH:i:sP"); },
        r: function() { return this.toString(); },
        U: function() { return this.getTime() / 1000; }
    };

    // Simulates PHP's date function
    Date.prototype.format = function(format) {
        var date = this;
        return format.replace(/(\\?)(.)/g, function(_, esc, chr) {
            return (esc === '' && replaceChars[chr]) ? replaceChars[chr].call(date) : chr;
        });
    };

}).call(this);
;
/**
 * Top level of the search page
 * Handles the page level stuff and triggers events on the individual search sources
 */
 
var SearchController = Backbone.Model.extend(
    /** @lends SearchControl.prototype */
    {
            
        defaults: function() {
            return {
                host_app: '',
                customer_id: 0,
                query_typed: '',
                lang: {},
                query_string: '',
                baseUrl: '',
                layout: 'tab',
                sources: [],
                tab_order: [],
                tab: '',
                selector: '',
                form_selector: '',
                header_selector: '',
                form_queue_id: 0,
                guide_id: 0,
                debug: false
            }
        },
        
        //@todo include default lang text
        
        /**
         * The main search controller
         * @param {String} host_app app where this js is currently running (la, lg, lc, etc)
         * @param {Number} customer_id libapps customer id
         * @param {String} query_typed what the user typed to search
         * @param {Object} lang language/translation values
         * @param {String} query_string url query string for current page
         * @param {String} baseUrl the path name for the current page, we need this for History states
         * @param {String} layout either tab or bento decides how many search interfaces are shown at once
         * @param {Array} sources array of search source objects with t.b.d. data in them used to create SearchInterface models
         * @param {Array} tab_order source ids of tab order
         * @param {String} [tab] current selected tab (for layout=tab only)
         * @param {String} selector selector for div that holds main interface (for tabs)
         * @param {String} [form_selector] selector for the search form (else we make one of our own)
         * @param {String} [header_selector] selector for area that says "search results for {{ query }}"
         * @param {Object} help parameters for the help alert
         * @todo decide what the hell to do with this
         * @param {String} help.noresults text when no results are found
         * @param {String} help.results text when results are found (shown at bottom of results)
         * @param {Number} help.la_widget_id for which widget to use in modal.
         * @param {Number} form_queue_id LA queue id for which form to display
         * @param {Number} guide_id For tracking searches from specific Guides (LG only)
         * @param {Boolean} debug set to true to output events/data to console
         */
        initialize: function() {
            this.set('baseUrl', location.pathname);
            this.protocol = window.location.protocol;
            
            //Set up history API so we can update URL and maintain forward/back buttons in browser
            this.useHistory = false;
            if (window.history && typeof history.pushState !== 'undefined') {
                //Enabled
                this.useHistory = true;
                this.History = window.History; // Note: We are using a capital H instead of a lower h	
                // Bind to State Change
                var self = this;
                this.History.Adapter.bind(window,'statechange',function(){
                    self.retrieve();
                });
            }
            
            // setup underscore template engine to use mustache style markers
            _.templateSettings = {
                escape:			/\{\{\{([^#].*?)\}\}\}/g,	// {{{ title }}}
                interpolate:	/\{\{([^#\{][\s\S]*?)\}\}/g,	// {{ title }}
                evaluate:		/\{\{#([\s\S]+?)\}\}/g			// {{# console.log("blah") }}
            }
            
            //to do a search we change the History state first
            this.on('search', this.pushState, this);
            //when the query gets changed we update elements of the page
            this.on('change:query_typed', this.updateQuery, this);
            
            //just a class to help on bento pages
            if (this.get('layout') == 'bento') {
                jQuery('body').addClass('s-srch-layout-bento');				
            }
            
            //figure out tabs and their order
            if ( this.get('layout') == 'tab' && this.get('tab_order').length == 0 ) {
                var tab_order = [];
                //first did we set it on the container
                var source_order = jQuery(this.get('selector')).attr('data-srch-sources');
                if (typeof source_order !== 'undefined' && source_order !== '') {
                    source_order = source_order.split(',');
                    _.each(source_order, function(v){
                        var s = _.findWhere(this.get('sources'), { id: parseInt(v, 10) });
                        if (typeof s !== 'undefined') {
                            tab_order.push(s.id);
                        }
                    }, this);
                    if (tab_order.length == 0) {
                        //gotta show something
                        tab_order = _.map(this.get('sources'), function(s){ return s.id; });
                    }
                } else {
                    //or just use them all
                    _.each(this.get('sources'), function(v,k,l){
                        tab_order.push(v.id);
                    });
                }
                this.set('tab_order', tab_order)
            }
            //set default tab
            if (this.get('layout') == 'tab' && this.get('tab') === '') {
                this.set('tab', this.get('tab_order')[0]);
            }
            
            var views = [];
            
            if (this.get('form_selector') !== '' && jQuery(this.get('form_selector')).length > 0) {
                var searchform = new SearchForm({ model: this, el: jQuery(this.get('form_selector')), formType: 'existing' });
            } else {
                var searchform = new SearchForm({ model: this, id: 's-srch-form' });
                views.push(searchform.el);
            }
            
            if (this.get('header_selector') == '' && this.get('layout') == 'tab') {
                var $header = $('<div id="s-srch-control-header"><h3></h3></div>');
                this.set('header_selector', '#s-srch-control-header');
                views.push($header);
            }
            
            //show tabs for more than 1 source
            if (this.get('layout') == 'tab' && this.get('tab_order').length > 1) {
                var tabs = new SearchTabs({ model: this, id: 's-srch-tabs' });
                views.push(tabs.el);
            }
            
            if (views.length > 0) {
                jQuery(this.get('selector')).append(views);
            }
        },
        /**
         * Debug (use in place of console.log())
         * @param {String|Number|Object} data data to log
         */
        debug: function(data) {
            if (this.get('debug')) {
                console.log(data);
            }
        },
        /**
         * Initialize the search source, we need to do this as separate from this.initialize() because we can't reference the searchcontroller in the sources until after it's initialized.
         */
        loadSources: function(){
    
            if (this.get('layout') == 'tab') {
                //set up tab content areas and source objects
                _.each(this.get('tab_order'), function(v,k,l){
                    var source = _.findWhere(this.get('sources'), { id: parseInt(v, 10) });
                    if (typeof source !== 'undefined') {
                        var selector = '#s-srch-source-'+source.id;
                        var $el = jQuery('<div id="s-srch-source-'+source.id+'"></div>').attr({ 'data-source': source.id, 'role': 'tabpanel' });
                        if (this.get('tab') != source.id) {
                            $el.addClass('hidden');
                        }
                        jQuery(this.get('selector')).append( $el );
                        source.lang = this.get('lang');
                        source.guide_id = this.get('guide_id'); // Add guide_id for searches initiated from a guide.
                        var sources = [];
                        switch (source.type){
                            case "la":
                                sources.push( new SearchLA(source) );
                                break;
                            case "lg":
                                sources.push( new SearchLG(source) );
                                break;
                            case "az":
                                sources.push( new SearchAZ(source) );
                                break;
                            case "blog":
                                sources.push( new SearchBlog(source) );
                                break;
                            default:
                                sources.push( new SearchInterface(source) );
                        }
                        
                        
                    }
                }, this);
                
                //In LA add the askform to the bottom
                if (this.get('host_app') == 'la') {
                    var askform = new AskView({ model: this, formtype: 'footer', alert_text: this.get('lang').srch_askqtext });
                    jQuery(this.get('selector')).append( askform.el );
                }
                
            } else {
                //bento
                _.each(this.get('sources'), function(v,k,l){
                    var selector = '#s-srch-source-'+v.id;
                    if (jQuery(selector).length == 0) {
                        return;
                    }
                    v.display_facets = false;
                    v.lang = this.get('lang');
                    var sources = [];
                    switch (v.type){
                        case "la":
                            sources.push( new SearchLA(v) );
                            break;
                        case "lg":
                            sources.push( new SearchLG(v) );
                            break;
                        case "az":
                            sources.push( new SearchAZ(v) );
                            break;
                        case "blog":
                            sources.push( new SearchBlog(v) );
                            break;                        
                        default:
                            sources.push( new SearchInterface(v) );
                    }
                }, this);
            }
            
        },
        /**
         * Update the history API state so we can change the url and enable back/forward button usage
         * Triggers the retrieve method
         * That is triggered outside of the controller via an event handler in search page
         */
        pushState: function() {
            this.debug('searchcontroller:pushState');
            var qs = this.buildQueryString();
            if (qs !== '') { qs = '?'+qs; } //so we don't have a trailing ? when there's a blank query string
            if (this.useHistory) {
                this.History.pushState(null,null,this.get('baseUrl')+qs);
                //History.pushState(null,null,this.get('baseUrl')+qs);
                //statechange triggers an action... as set in initialize()
            } else {
                //if we don't have history (IE) just load new page
                window.location(this.get('baseUrl')+qs);
            }
        },
        /**
         * called on load and state change, triggers event that searchinterfaces listen for
         */
        retrieve: function() {
            this.debug('searchcontroller:retrieve');
            //parse the query string for parameters
            this.parseQueryString();
            
            this.trigger('search:initiate', { source: 'controller' });
            //leave it to the SearchInterfaces to decide whether they should run or not (based on tab/layout)
        },
        /**
         * What's in the query string? Let's make it an object we can use.
         */
        parseQueryString: function(){
            var qs = location.search.slice(1);
            this.set('query_string',qs);
            
            var pairs = qs.split('&');
            //this.debug(pairs);
            
            var result = {};
            
            _.each(pairs, function(pair) {
                pair = pair.split('=');
                if (pair[0] == '' || !pair[1]) { return; }
                
                if (pair[0] == 'q') {
                    result[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, ' ') || '');
                } else {
                    result[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, ' ') || '');
                }	
            }, this);
            
            if (result.q) {
                this.set('query_typed', result.q);
            } else {
                this.set('query_typed', '');
            }
            
            if (result.t) {
                this.set('tab', result.t);
            } else {
                //this.set('tab', '');
            }
            
            //Various facets
            if (result.topics && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'topics', value: result.topics });
            }
            
            if (result.keywords && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'keywords', value: result.keywords });
            }
    
            if (result.g && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'g', value: result.g });
            }
            
            if (result.subject && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'subject', value: result.subject });
            }
            
            if (result.tag && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'tag', value: result.tag });
            }
            
            if (result.group && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'group', value: result.group });
            }
            
            if (result.content_type && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'content_type', value: result.content_type });
            }
            
            if (result.guide_type && this.get('layout') == 'tab') {
                this.trigger('facet:set', { facet: 'guide_type', value: result.guide_type });
            }
            
            return result;
        },
        /**
         * Build a query string (for the visible URL) based on current attributes
         * sets the query_string attribute
         */
        buildQueryString: function() {
            /*
                Fields we use and defaults:
                    query: '',
                    tab: '', //tab to show
                    topic: '', //can be passed to LA interface
            */
            
            var params = {};
            
            if (this.get('query_typed') !== '') {
                params.q = this.get('query_typed');
            }
            if (this.get('tab') !== '') {
                params.t = this.get('tab');
            }
            
            var qs = jQuery.param(params, true); //true makes sure we repeat keys in query string for arrays
            this.set('query_string',qs);
            return qs;
        },
        /**
         * on query change we update any qforms on the page, the search header
         */
        updateQuery: function() {
            var q = this.get('query_typed');
            
            //update forms
            $('textarea[name=pdetails]').val(q);
            //update header
            $(this.get('header_selector')).text(this.get('lang').srch_boxhead+' ').append( jQuery('<em></em>').text(q) );		
        }
            
    });
    
    /**
     * //!SearchForm View
     * The text input for searching (1 per page)
     */
    var SearchForm = Backbone.View.extend(
    /** @lends SearchForm.prototype */
    {
        
        model: SearchController,
        tagName: 'form',
        className: 'form-inline',
        formType: '',
        
        events: {
            'submit': 'submit',
        },
        
        initialize: function(options) {
            if (options.formType) {
                this.formType = options.formType;
            }
                    
            this.render();
            
            var q = this.model.get('query_typed');
            
            if (this.model.get('layout') == 'tab') {
                var $results_div = jQuery(this.model.get('selector'));
                var results_id = $results_div.attr('id');
                if (results_id == '') {
                    results_id = 's-srch-results-container';
                    $results_div.attr('id', results_id);
                }
                this.$input.attr('aria-controls', results_id);
            } else {
                //set this to all the ids for the results div(s)
    
            }
            
            this.$input.val(q);
            
            //this.setupAutocomplete();
            
            this.listenTo(this.model, 'change:query_typed', this.setQuery);
            //this.listenTo(this.input, 'typeahead:selected', sresults.goToAnswer)
        },
        
        render: function() {
            
            if (this.formType == 'existing') {
                this.$input = this.$('input[name=q]');
                return;			
            }
    
            var inputs = [];
            
            this.$input = jQuery('<input type="text" class="s-srch-form-input form-control" id="primaryquery" name="q" value="" />');
            var $label = jQuery('<label for="" class="control-label sr-only" for="primaryquery">Keyword Search</label>');
            
            inputs.push( jQuery('<div class="form-group"></div>').append([$label, this.$input]) );
            inputs.push( jQuery('<button type=submit class="btn btn-default">Search</button>') );
            
            this.$el.append(inputs);	
        },
        
        setQuery: function(e) {
                
            this.$input.val(this.model.get('query_typed'));
        },
        
        /**
         * search on a query
         */
        submit: function(e) {
            e.preventDefault();
            
            var new_query = this.$input.val(); 
            if (new_query !== this.model.get('query_typed')) {
            
                //check for odd number of quotes
                var quotes = (new_query.match(/"/g)||[]).length;
                //this.debug(quotes);
                if (quotes % 2 !== 0) {
                    errorAlert(this.model.get('lang').srch_syntaxerror);
                    return;
                }
            
                this.model.set('query_typed', new_query);
                this.model.trigger('search');
            }		
            //this.input.typeahead('close');
        },
        
        /**
         * Turn on the autocomplete
         * @todo this could probably be cleaner
         */
    /*
        setupAutocomplete: function() {
            
            var self = this;
            self.qo = this.model.buildQuery(true);    
            self.qo.rows = 10;
            
            //data source for typeahead
            //I think we could do this as a method on the view (or the model).
            //bind it to this
            var typeahead_source = function(query, cb) {
                var results = [];
                query = jQuery.trim(query);
                self.qo.q = query.replace(/([\(\)\[\]\{\}\^~:\\\/])/ig, '\\$1') + '*';
                //self.qo.q = query+'*';
                $.ajax({
                    url: 'http://'+self.model.get('solrUrl')+'/'+self.model.get('solrIndex')+'/select',
                    data: self.qo,
                    success: function(d){
                        results = jQuery.map(d.response.docs, function(item) {
                            return { value: item.question, faqid: item.id, gid: item.g };
                        });
                        cb(results);
                    },
                    traditional: true, //this lets the query have multiple parameters that don't use the [] syntax (cause solr wants that)
                    dataType: 'jsonp',
                    jsonp: 'json.wrf'
                });
                        
            }
            
            //enable autocomplete
            this.input.typeahead({ minLength: 3 },
                {
                    source: typeahead_source,
                    displayKey: 'value'
                }
            ).on('typeahead:selected', function(e, d){
                //when a suggestion is selected
                jQuery.ajax({
                    type: 'POST',
                    url: '/process_public.php?m=gotoa',
                    data: { faqid: d.faqid, qlog: springSpace.la.Page.qlog_id },
                    async: false,
                    success: function (data) {
                        return true;
                    }
                });
                
                window.location.href = '/a.php?gid='+d.gid+'&qid='+d.faqid;
            });
            
        },
    */
    
    
    });
    
    /**
     * //!SearchTabs View
     * The tabs for tabbed layout
     */
    var SearchTabs = Backbone.View.extend(
    /** @lends SearchTabs.prototype */
    {
        
        model: SearchController,
        tagName: 'div',
        id: 's-srch-tabs',
        
        events: {
            'click button': 'changeTab',
        },
        
        initialize: function() {
            this.model.debug('SearchTabs:initialize');
            if ( this.model.get('layout') !== 'tab') {
                return false;
            }
            
            this.render();
                    
            this.listenTo(this.model, 'change:tab', this.setTab);
        },
        /**
         * Change the tab
         */
        changeTab: function(e){
            e.preventDefault();
            var $b = $(e.currentTarget);
            var $li = $b.parent('li');
            if ($li.hasClass('active')) {
                return;
            }
            this.$('li').removeClass('active')
            this.$('button').attr({ 'aria-selected': 'false' });
            $li.addClass('active');
            $li.find('button').attr({ 'aria-selected': 'true' });
            var id = $li.attr('data-source');
            this.model.set('tab', id);
            this.model.trigger('search');
        },
        /**
         * Make the current tab display as active
         */
        setTab: function() {
            var tab = this.model.get('tab');
            this.$('li').removeClass('active');
            this.$('button').attr({ 'aria-selected': 'false' });
            this.$('li[data-source='+tab+']').addClass('active').find('button').attr({ 'aria-selected': 'true' });
        },
        /**
         * Render tabs
         */
        render: function() {
            this.model.debug('SearchTabs:render');
            this.$el.html('');
            
            var $ul = jQuery('<ul></ul>').addClass('list-inline').attr({ 'role': 'tablist'});
            
            var cur_tab = this.model.get('tab');
            this.model.debug(cur_tab);
            //_.each(this.model.get('sources'), function(v,k,l) {
            _.each(this.model.get('tab_order'), function(v,k,l){
                var source = _.findWhere(this.model.get('sources'), { id: parseInt(v, 10) });
                if (typeof source !== 'undefined') {
                    var $li = jQuery('<li></li>').attr({ 'data-source': source.id, 'role': 'presentation' });
                    var $button = jQuery('<button></button>').attr({ 'type': 'button', 'aria-controls': 's-srch-source-'+source.id, 'role': 'tab' }).addClass('btn btn-default').text(source.name);
                    if (cur_tab == source.id) {
                        $li.addClass('active');
                        $button.attr({ 'aria-selected': 'true' });
                    }
                    $li.append($button);
                    $ul.append($li);
                }
            }, this);
            this.model.debug(this.$el);
            this.$el.append($ul);
        }
        
    });
    
    //!AskView
    /**
     * This is used by the controller and the searchinterfaces to provide "no results" alerts/question form button
     */
    var AskView = Backbone.View.extend(
    /** @lends AskView.prototype */
    {
        
        model: SearchController,
        tagName: 'div',
        className: 's-srch-askbutton col-sm-12 hidden',
        formtype: 'noresults',
        alert_text: 'No results found.',
        
        events: {
            'click .btn': 'showQForm',
        },
        
        /**
         * Ask Q button
         */
        initialize: function (options) {
            if (options.formtype) {
                this.formtype = options.formtype;
            }
            if (options.alert_text) {
                this.alert_text = options.alert_text;
            }
            
            this.listenTo(this.model, "search:retrieve", this.results);
            this.listenTo(this.model, "search:noresults", this.noresults);
            this.listenTo(this.model, "askform:results", this.results);
            this.listenTo(this.model, "askform:noresults", this.noresults);
            this.render();
        },
        
        render: function () {
    
            var $span = $('<p class="alert alert-info"></p>').html(this.alert_text);
            
            if (searchcontroller.get('form_queue_id') > 0) {
                var $a = $('<a class="btn btn-primary" href="#" role=button></a>').html(this.model.get('lang').srch_askqbutton);
                $span.append($a);
            }
            
            this.$el.html($span);
                
        },
        /**
         * When results are found
         */
        results: function(){
            if (this.formtype == 'noresults') {
                this.$el.addClass('hidden').attr('aria-hidden', 'true');
            } else {
                this.$el.removeClass('hidden').attr('aria-hidden', 'false');
            }
        },
        /**
         * When results are not found
         */
        noresults: function(e){
            if (this.formtype == 'noresults') {
                this.$el.removeClass('hidden').attr('aria-hidden', 'false');
            } else {
                this.$el.addClass('hidden').attr('aria-hidden', 'true');
            }
        },
        /**
         * Onclick action for the no results 'Ask question' button
         * Pops up a modal with the qform
         */
        showQForm: function(e) {
            e.preventDefault();
            var query = this.model.get('query_typed');
            //this.model.debug(query);
            //var queue_id = this.model.get('form_queue_id');
            var queue_id = searchcontroller.get('form_queue_id');
            
            var url = '';
            
            //resize the iframe in the modal to match the size of the qform
            window.addEventListener('message', function(e){
                if (e.data && _.isObject(e.data) && e.data.action && e.data.action == 'qformloaded') {
                    if (e.data.height && parseInt(e.data.height, 10) > 0) {
                        jQuery('.qform_frame').css('height', e.data.height);
                    }
                }
            });
            
            var qlog_id = 0;
            if (springSpace && springSpace.querySpy) {
                qlog_id = springSpace.querySpy.qlog_id || 0;
            }
            
            var modal = new springSpace.sui.modal({ title: this.model.get('lang').srch_askqbutton, content: '<iframe class="qform_frame" src="/form.php?queue_id='+queue_id+'&iframe=1&qlog_id='+qlog_id+'&pquestion='+query+'"></iframe>', callback: function(){  } });
            
        },
        
    });
    
    
    //!HELPERS
    
    /**
     * Capitalize first letter of string
     */
    String.prototype.capitalize = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }
    
    
    /**
     * Compare two arrays
     * @param {Array} arr1
     * @param {Array} arr2
     * @returns {Boolean} are they the same
     */
    function compareArrays(arr1, arr2) {
        arr1 = arr1.sort();
        arr2 = arr2.sort();
        
        if (arr1.length != arr2.length)
            return false;
    
        for (var i = 0, l=arr1.length; i < l; i++) {
            // Check if we have nested arrays
            if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
                // recurse into the nested arrays
                if (!arr1[i].compare(arr2[i]))
                    return false;
            }
            else if (arr1[i] != arr2[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
        
    }
    
    ;
/**
 * Search Interface, subclass for specific searches
 * requires backbone.js
 */
 


var SearchInterface = Backbone.Model.extend(
	/** @lends SearchInterface.prototype */
	{
		
	defaults: function() {
		return {
			id: '',
			type: '',
			name: '',
			site_url: '',
			search_url: '',
			results: [],
			total_results: 0,
			page: 1,
			perpage: 20,
			query_typed: null,
			query_obj: {},
			request_url: '',
			display_facets: false,
			item_template: '',
			item_callback: '',
			sort_options: [],
			sort: { field: '', dir: '' },
		};
	},

	/**
	 * The main search interface
	 * @param {Object} config variables from the search source data
	 * @param {String} config.id unique identifier for search source
	 * @param {String} config.type used by controller to know what class to use (should be unique across sources but not necessarily across instantiations of the subclass
	 * @param {String} config.name just a human readable label for the source
	 * @param {String} config.description text to describe the source for people
	 * @param {String} config.site_url top-level domain of the source (for making URLs)
	 * @param {String} [config.search_url] dedicated/advanced search url for source
	 * @param {Object} config.facets the facets as properties with their value as arrays of currently selected limits
	 * @param {Array} config.results the retrieved results for the current search page
	 * @param {Number} config.total_results how many total results for search/filters (independent of pagination)
	 * @param {Number} config.page currently view page
	 * @param {Number} config.perpage how many results per page
	 * @param {Object} config.sort default sorting parameters in the form of field and dir properties
	 * @param {String} config.query_typed the keyword search string
	 * @param {Object} config.query_obj all the fields and values that need to go to Solr for the query
	 * @param {String} config.request_url domain/path to request data from
	 * @param {Bool} config.display_facets do we show facets or not
	 * @param {String} config.item_template an mustache like template for result items
	 * @param {Function} config.item_callback callback applied to each result LI element after results are added to DOM
	 * @param {Object[]} config.sort_options options for sorting the results
	 * @param {String} config.sort_options[].field name of sorting field
	 * @param {String} config.sort_options[].dir direction of sort (asc/desc)
	 * @param {String} config.sort_options[].label human readable name of sorting field
	 * @param {Object} config.query_const key->value pairs to pass to request_url, you can also pass back these keys in the results to update them
	 */
	initialize: function(config) {
		searchcontroller.debug('SearchInterface '+this.get('type')+' initialize');
		this.resultCache = {};
		this.facetCache = {};
		
		this.protocol = window.location.protocol;
		
		//set config options
		this.setConfig(config);
		
		if (searchcontroller.get('layout') == 'bento') {
			this.set('perpage', 10);
		}
		
		if (this.get('search_url') !== '' && !_.isNull(this.get('search_url'))) {
			if ( this.get('search_url').substr(0, 4) !== 'http' && this.get('search_url').substr(0, 2) !== '//') {
				this.set('search_url', '//'+this.get('search_url'));
			}
		}
		
		//listen on SearchController for the search:initiate event this means the page has loaded, the keyword has changed, or tab was selected
		this.listenTo(searchcontroller, "search:initiate", this.newSearch);
		this.on('search:initiate', this.newSearch, this);
		//trigger events on the controller when results are or are not found
		this.on('search:noresults', this.controllerno, this);
		this.on('search:retrieve', this.controlleryes, this);
		
		//@todo this will need to be conditional on the controller... only viewed interfaces get initialized (or rather they get initialized when viewed)
		this.renderViews();
	},
	/**
	 * Tell the search controller there were no results
	 */
	controllerno: function(){
		searchcontroller.trigger('search:noresults', { source: this.get('id') });
	},
	/**
	 * Tell the search controller there were results retrieved
	 */
	controlleryes: function(){
		searchcontroller.trigger('search:retrieve', { source: this.get('id') });
	},
	/**
	 * Set properties based on config object sent from SearchController
	 * override in subclass as necessary
	 * @param {Object} config customer settings for this interface
	 * Object should at least contain id, type, name
	 */
	setConfig: function(config) {
		_.each(config, function(v,k,l){
			if (_.isNull(v)) { return; }
			this.set(k, v, { silent: true });
		}, this);
		
		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });
		return;	
	},
	/**
	 * Load up the views for this interface
	 */
	renderViews: function(){
		var $container = jQuery(this.get('selector'));
		var views = [];
		
		var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		
		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });
		var resultslist = new ResultsList({ model: this, id: 's-srch-results-'+this.get('id') });
		//var askform = new AskView({ model: this, formType: 'noresults', alert_text: this.get('lang').srch_notasked, source: this.get('id') });
		
		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}
		views.push( jQuery('<div class="row"></div>').append([searchheader.$el, top_pagination.$el]) );
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );
		//views.push( jQuery('<div class="row"></div>').append(askform.$el) );
		
		$container.append( views );
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		//searchcontroller.debug('buildQuery');
		
		qo = {
			q: this.convertSearch(),
			page: this.get('page')
		};
		
		//add search source id for locally proxied searches
		if ( this.get('request_url').match(/^\/[^/]/) !== null ) {
			qo.search_src_id = this.get('id');
		}
		
		s = this.get('sort');
		qo.sort = s.field+'_'+s.dir;
		
		if (this.get('query_const')) {
			_.each(this.get('query_const'), function(v,k){
				qo[k] = v;
			}, this);
		}
		
		this.set('query_obj', qo);
	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * override in subclass
	 */
	convertSearch: function() {
		return (this.get('query_typed') === null) ? '' : this.get('query_typed');
	},
	/**
	 * A new keyword search triggered by the SearchController
	 * @param {Object} d data passed to action via search:initiate event
	 * @param {String} d.source origin of search (controller, facet, sort, paginate)
	 */
	newSearch: function(d) {
		searchcontroller.debug(this.get('type')+' newSearch');
		if (searchcontroller.get('layout') !== 'bento') {
			//make sure it's for this tab
			if (parseInt(searchcontroller.get('tab'), 10) !== parseInt(this.get('id'), 10)) {
				jQuery(this.get('selector')).addClass('hidden');
				return;
			} else {
				jQuery(this.get('selector')).removeClass('hidden');
			}
		}
		
		if (d.source == 'controller' && this.get('query_typed') !== null && this.get('query_typed') === searchcontroller.get('query_typed')) {		
			//don't do anything if the query hasn't changed (probably this means we changed tabs)
			//trigger askform view
			if (this.get('total_results') == 0) {
				searchcontroller.trigger('askform:noresults');	
			} else {
				searchcontroller.trigger('askform:results');
			}
			return;
		}
		this.set('query_typed', searchcontroller.get('query_typed'));
		
		if (d.source !== 'paginate') {
			this.set('page', 1);  //reset page to 1
		}
		
		this.retrieve();
	},
	/**
	 * ajax call to source for results
	 * triggered on load and state change
	 */
	retrieve: function() {
		searchcontroller.debug(this.get('type')+' retrieve');
		
		//make sure we have the current query object
		this.buildQuery();
		
		//do we have this data cached?
		//set cache via...
		var cachename = JSON.stringify(this.get('query_obj'));
		if (this.resultCache[cachename]) {
			//searchcontroller.debug('cached!');
			this.parseResults(this.resultCache[cachename]);
			this.setFocus();
			return;
		}
		
		//the ajax itself
		this.requestData();
	},
	/**
	 * Request the data (an ajax request)
	 */
	requestData: function() {
		var self = this;
		
		workingAlert();
		try {
			$.ajax({
				url: this.get('request_url'),
				data: this.get('query_obj'),
				success: function(d, status){
					clearTimeout(requestError);
					self.cacheResults(d);
					self.parseResults(d);
					self.setFocus();
					stopAlert();
				},
				dataType: 'jsonp',
			});
			
			//because jsonp doesn't return errors normally we gotta just timeout
			var requestError = setTimeout(function() { 
				// Handle error accordingly
				errorAlert();
			}, 10000);
		
		} catch (e) {
			searchcontroller.debug('requestData exception for source '+this.get('id')+': '+e.message);
			errorAlert();
		}
	},
	/**
	 * Cache data based on query string so we can access it via the history state on back/forward button usage
	 * @param {Object} data results from solr
	 */
	cacheResults: function(data) {
		this.resultCache[JSON.stringify(this.get('query_obj'))] = data;
	},
	/**
	 * Cache facet data based on query object so we can access it via the history state on back/forward button usage
	 * @param {Object} data results from solr
	 */	
	cacheFacets: function(qs, data) {
		this.facetCache[qs] = data;		
	},
	/**
	 * Update the facets only for query string or group change.
	 * Facets are returned based on query string and group only.
	 */
	retrieveFacets: function() {
		return;
	},	
	/**
	 * Apply facet data retrieved from Solr
	 */
	parseFacets: function(data) {
		return;
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from query
	 * @param {Object[]} data.results array of result items
	 * @param {Object} data.results[] item object properties don't matter if we use a template
	 * @param {Number} data.total_results total hits for query
	 * @param {Number} data.perpage how many results per page
	 */
	parseResults: function(data) {
		var fields = {
			'results': [],
			'total_results': 0,
			'perpage': 0
		};
		
		if (_.isObject(data) & data != null) {		
			//trigger search:retrieve or search:noresults
			fields.results = (data.results) ? data.results : [];
			fields.total_results = (data.total_results) ? data.total_results : 0;
			fields.perpage = (data.perpage) ? data.perpage : 0;
			if (data.sort) {
				fields.sort = data.sort;
			}
			if (data.sort_options) {
				fields.sort_options = data.sort_options;
			}
		}
		this.set(fields);
		if (fields.total_results === 0) {
			this.trigger('search:noresults');	
		} else {
			this.trigger('search:retrieve');
		}
		if (this.get('display_facets')) {
			this.retrieveFacets();
		}
		
		if (this.get('query_const')) {
			//you can update the query_const by passing back a value in the results
			//this is especially used for EDS sessionid
			var query_const = _.clone(this.get('query_const'));
			var update = false;
			_.each(query_const, function(v,k){
				if (data[k]) {
					query_const[k] = data[k];
					update = true;
				}
			}, this);
			if (update) {
				this.set('query_const', query_const, { silent: true });
			}
		}
	},
	/**
	 * Add a facet filter
	 * @param {String} facet which facet
	 * @param {String} value which facet value
	 */
	addFacet: function(facet, value) {
		var facets = this.get('facets');
		
		if (facets[facet]) {
			//make sure its not a dupe
			if (_.indexOf(facets[facet], value) == -1) {
				facets[facet].push(value);
				this.trigger('search:initiate', { source: 'facet' });
				this.trigger('facet:add', { type: facet, value: value });
			}
		}
	},
	/**
	 * Set a facet filter as the only facet filter
	 * @param {String} facet which facet
	 * @param {String} value which facet value
	 * @param {Bool} [all=true] set as only facet or just as only value for the specific facet
	 * @param {Bool} [initiate=true] should we initiate a search when setting this facet
	 */
	setFacet: function(facet, value, all, initiate) {
		searchcontroller.debug(this.get('type')+' setFacet');
		var facets = _.clone(this.get('facets'));
		
		if (typeof all == 'undefined' || all) {
			f = _.keys(facets);			
			facets = {};
			_.each(f, function(v){
				facets[v] = [];
			}, this);
			facets[facet].push(value);
		} else {
			facets[facet] = [value];
		}
		this.set('facets', facets);
		if (typeof initiate == 'undefined' || initiate) {
			this.trigger('search:initiate', { source: 'facet' });
		}
	},
	/**
	 * Remove a facet (or all of them)
	 * @param {String} [facet] which facet (if undefined remove all)
	 * @param {String} [value] which facet value (if undefined remove all)
	 */
	removeFacet: function(facet, value) {
		var facets = _.clone(this.get('facets'));
		//searchcontroller.debug(facets);

		if (typeof facet == 'undefined') {
			//remove all
			f = _.keys(facets);
			
			facets = {};
			_.each(f, function(v){
				facets[v] = [];
			}, this);
			this.set('facets', facets);
			this.trigger('search:initiate', { source: 'facet' });
		}
		//remove one
		if (facets[facet]) {
			if (typeof value == 'undefined') {
				//remove the whole facet
				facets[facet] = [];
			} else {
				//remove specific value of facet			
				var i = _.indexOf(facets[facet], value);
				if (i > -1) {
					facets[facet].splice(i, 1);
				}
			}
			this.set('facets', facets);
			this.trigger('search:initiate', { source: 'facet' });
		}		
	},
	/**
	 * Remove All Facets
	 * @param bool query_too should we also clear search query
	 */
	removeAllFacets: function(query_too) {
		if (typeof query_too == 'undefined') {
			query_too = false;
		}
		//remove all facets
		var facets = _.clone(this.get('facets'));
		f = _.keys(facets);			
		facets = {};
		_.each(f, function(v){
			facets[v] = [];
		}, this);
		this.set('facets', facets);

		if (query_too && this.get('query_typed') !== '') {
			searchcontroller.set('query_typed', '');
			searchcontroller.trigger('search');
		} else {
			this.trigger('search:initiate', { source: 'facet' });
		}
	},
	/**
	 * Sets focus on an attribute after the search runs
	 */
	setFocus: function() {
		if (this.get('focus_target') !== '') {
			jQuery('#'+this.get('focus_target')).focus();
			this.set('focus_target', '');
		}
	}
	
});


//!ResultsList View
var ResultsList = Backbone.View.extend(
/** @lends ResultsList.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-resultlist col-sm-12',
	item_template: '',
	attributes: { 'aria-live': 'polite' },
	
	/**
	 * Results list for SearchInterface
	 *
	 * @augments external:Backbone.View
	 * @constructs
	 */
    initialize: function(options) {
		searchcontroller.debug('ResultsList:initialize');
        this.listenTo(this.model, "search:retrieve", this.render);
		this.listenTo(this.model, "search:noresults", this.noResults);
    },
    /**
     * When results are retrieved, display them
     */
    render: function () {
		var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
		var results = this.model.get('results');
		if(results && results.length > 0) {
			_.each(results, function(v,k,l){		
				$list.append(this.resultItem(v));
			}, this);
		}
		this.$el.html($list).attr({ 'aria-labelledby': 's-srch-params-'+this.model.get('id') });
		
		if (this.model.get('item_callback') !== '') {
			var self = this;
			var func = new Function(this.model.get('item_callback'));
			$list.find('li').each(function(i,el){
				//call item_callback with the LI element as this
				func.apply(this);
			});
		}
		
		return this;
    },
    /**
     * When no results are retrieved show something
     */
    noResults: function() {
		$(this.el).html('');
		return this;
    },
	/**
	 * A single result item
	 * @param {Object} item
	 * @return {Object} jQuery object
	 */
	resultItem: function(item) {
		var $li = $('<li></li>').addClass('s-srch-result');
		var html = '';
		
		if (this.model.get('item_template') === '') {
			this.model.set('item_template',
				'<a href="{{url}}">{{title}}</a>',
				{ silent: true });
		}
		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}
		try {
			html = this.item_template(item);
		} catch(e) {
			searchcontroller.debug(e);
			return '';
		}
		
		return $li.html( html );
	}
	
});


//!SearchHeader View
var SearchHeader = Backbone.View.extend(
/** @lends SearchHeader.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-header clearfix',
	
	events: {
		'click .s-srch-sorter': 'doSort',
	},
	
	/**
	 * Search header for results number, sorting
	 */
	initialize: function() {
		if (searchcontroller.get('layout') == 'bento') {
			this.$el.addClass('col-sm-12');
		} else {
			this.$el.addClass('col-sm-6');
		}
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * Display the content
	 */
	render: function() {
		this.$el.html('');
	
		var total = this.model.get('total_results');
		var perPage = this.model.get('perpage');
		var offset = (this.model.get('page') - 1) * perPage;
		
		this.$rangeHeader = $('<div class="s-srch-range pull-left"></div>');
		this.$rangeHeader.html($('<span></span>').text(springSpace.Util.stringFormat(this.model.get('lang').srch_resrange, [Math.min(total, offset + 1) + ' - ' + Math.min(total, offset + perPage), total])));
		
		var sort_list = '';
		if (this.model.get('sort_options').length > 1) {
			var cur_sort = this.model.get('sort');
			_.each(this.model.get('sort_options'), function(v,k){
				var chk = (cur_sort.field == v.field && cur_sort.dir == v.dir) ? '<i class="fa fa-fw fa-check"></i>' : '<i class="fa fa-fw"></i>';
				sort_list += '<li><a href="#" role=button class="s-srch-sorter" data-field="'+v.field+'" data-direction="'+v.dir+'" aria-controls="s-srch-results-'+this.model.get('id')+'">'+chk+' '+v.label+'</a></li>';
				
			}, this);
		}
		
		if (sort_list !== '') {
			var o = '<div class="dropdown">'+
				'<button id="s-srch-sort-'+this.model.get('id')+'-btn" type="button" class="btn btn-default btn-xs" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'+
					this.model.get('lang').srch_sorthead+' '+
					'<span class="caret"></span>'+
				'</button>'+
				'<ul class="dropdown-menu" aria-labelledby="s-srch-sort-'+this.model.get('id')+'-btn">'+
					sort_list+
				'</ul>'+
			'</div>';
			this.$rangeHeader.append(o);
		}
		
		this.$el.append([this.$rangeHeader]);
	},	
	/**
	 * Apply the new sort on click, trigger search
	 * @param {Object} e event object
	 */
	doSort: function(e) {
		e.preventDefault();
		
		var $a = $(e.currentTarget);
		var f = $a.attr('data-field');
		var d = $a.attr('data-direction');
		
		this.model.set('sort',  { field: f, dir: d });		
		this.model.set('focus_target', this.$('.dropdown button').attr('id'));
		this.model.trigger('search:initiate', { source: 'sort' });
	}

});

//!SearchFooter View
var SearchFooter = Backbone.View.extend(
/** @lends SearchFooter.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-footer clearfix col-sm-6',
	
	events: { },
	
	/**
	 * Search footer for see more link
	 */
	initialize: function() {
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * Display the content
	 */
	render: function() {
		this.$el.html('');
	
		if (searchcontroller.get('layout') == 'bento' && this.model.get('search_url')) {
			var $more = jQuery('<div></div>').addClass('s-srch-fulllink');
			var query = (this.model.get('query_typed')) ? this.model.get('query_typed') : '';
			var url = this.model.get('search_url').replace('{{query}}', encodeURIComponent(query));
			var $fulllink = jQuery('<a></a>').html( '<i class="fa fa-external-link"></i> '+this.model.get('lang').srch_seemore ).attr({ href: url, target: '_blank' });
			$more.append($fulllink);
			this.$el.append($more);
		}
	}
});

//!PaginationView
var PaginationView = Backbone.View.extend(
/** @lends PaginationView.prototype */
{
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-pagination',
	location: 'top',
	
	events: {
		'click .pagination a': 'changePage',	
	},
	
	initialize: function(options) {
		if (options.location) {
			this.location = options.location;
		}		
		
		if (this.location == 'bottom') {
			if (searchcontroller.get('layout') == 'bento') {
				this.$el.addClass('s-srch-pagination-bottom col-sm-6');
			} else {
				this.$el.addClass('s-srch-pagination-bottom col-sm-12');
			}
		} else {
			if (searchcontroller.get('layout') == 'bento') {
				this.$el.addClass('col-sm-4');
			} else {
				this.$el.addClass('col-sm-6');
			}
		}
		
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * Build the page links
	 */
	render: function() {
		var total = this.model.get('total_results');
		var perPage = this.model.get('perpage');
		
		this.$pager = $('<ul class="pagination pull-right" role="listbox"></ul>').attr('aria-label', this.model.get('lang').srch_pagelabel);
		
		var totalPages = Math.ceil(total / perPage);
		var curPage = parseInt(this.model.get('page'), 10);
		
		if (totalPages > 1) {
			var pagelinks = [];
			if (curPage > 1) {
				//prev page link
				p = curPage-1;
				var $li = $('<li class="pager-step" role="presentation"></li>');
				var $a = $('<a>&lt;</a>').attr({ 'href': '#', 'data-page': p, 'aria-controls': 's-srch-results-'+this.model.get('id'), 'role': 'option' });
				$li.append($a);
				pagelinks.push($li);
			}
			
			//loop
			var startpage = ((curPage - 2) < 1) ? 1 : curPage - 2;
			var endpage = startpage + 4;
			if (endpage > totalPages) { endpage = totalPages; }
			var p = startpage;
			while (p <= endpage) {
				var $li = $('<li role="presentation"></li>');
				var $a = $('<a>'+p+'</a>').attr({ 'href': '#', 'data-page': p, 'aria-controls': 's-srch-results-'+this.model.get('id'), 'role': 'option' });
				if (p == curPage) {
					$li.addClass('active');
					$a.attr({ 'aria-selected': 'true' });
				}
				$li.append($a);
				pagelinks.push($li);
				p++;
			}
			
			if (curPage < totalPages) {
				//next prev link
				var p = curPage+1;
				var $li = $('<li class="pager-step" role="presentation"></li>');
				var $a = $('<a>&gt;</a>').attr({ 'href': '#', 'data-page': p, 'aria-controls': 's-srch-results-'+this.model.get('id'), 'role': 'option' });
				$li.append($a);
				pagelinks.push($li);
			}
			
			this.$pager.append( pagelinks );
		}
		
		this.$el.html(this.$pager);
	},
	/**
	 * Pagination click event
	 * sets the page attribute and triggers a search (passing along paginate=true so the page doesn't get reset)
	 * @param {Object} e event object
	 */
	changePage: function(e) {
		e.preventDefault();
		var page = $(e.currentTarget).attr('data-page');
		var curPage = this.model.get('page');
		
		if (curPage !== page) {
			this.model.set('page', page);
			this.model.trigger('search:initiate', { source: 'paginate' });
		}
	}

});


//!FacetView
var FacetView = Backbone.View.extend(
/** @lends FacetView.prototype */
{
	
	model: SearchInterface,
	tagName: 'div',
	className: 's-srch-facet',
	facetType: '',
	
	events: {
		'change input[type=checkbox]': 'toggleFacet',
		'hide.bs.collapse .s-srch-cloud': 'toggleCollapseIcon',
		'show.bs.collapse .s-srch-cloud': 'toggleCollapseIcon',
	},
	
	/**
	 * Facet display
	 */
	initialize: function(options) {
		if (options.facetType) {
			this.facetType = options.facetType;
		}
				
		this.listenTo(this.model, 'facets:retrieve', this.makeList);
		this.render();
	},	
	/**
	 * create the display
	 */
	render: function() {		
		return this;
	},
	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		return;		
	},
	/**
	 * Apply/remove facet via checkbox change event
	 */
	toggleFacet: function(e) {
		var $ch = $(e.currentTarget);
		
		var facet = $ch.attr('name');
		
		if ($ch.prop('checked') === true) {
			this.model.addFacet(this.facetType, facet);
		} else {
			this.model.removeFacet(this.facetType, facet);
		}
	},
	/**
	 * Toggle the facet visibility caret icon
	 */
	toggleCollapseIcon: function(e) {
		var $btn = jQuery(e.currentTarget).prev('h3').find('button span i');
		if ($btn.length === 0) { return; }
		if (e.type == 'hide') {
			$btn.removeClass('fa-caret-down').addClass('fa-caret-right');
		} else if (e.type == 'show') {
			$btn.removeClass('fa-caret-right').addClass('fa-caret-down');
		}
	}
	
});


//!CurrentParamsView
/**
 * Shows the currently selected facet limiters
 */
var CurrentParamsView = Backbone.View.extend(
/** @lends CurrentParamsView.prototype */
{
	model: SearchInterface,
	tagName: 'div',
	className: 'col-sm-12 hidden',
	events: {
		'click .removeAll': 'removeAll'
	},
	/**
	 * Facet display
	 */
	initialize: function() {
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.render);
	},
	/**
	 * create the display
	 */	
	render: function() {
		return this;
	},
	/**
	 * remove all limiters
	 * @param {Object} e click event object 
	 */
	removeAll: function(e) {
		e.preventDefault();
		this.model.removeFacet();	
	}
});
;
/**
 * SearchLA, subclass of SearchInterface
 * requires backbone.js
 */

var SearchLA = SearchInterface.extend({
	/** @lends SearchLA.prototype */


	/**
	 * Set the interface's config options
	 * @param {Object} config
	 * @param {Int} config.iid LA iid
	 * @param {Boolean} config.isDefaultGroup is this the default search all groups page (only false in some LA group pages)
	 * @param {Array} config.group_id_default default group limit for this page (only set in LA)
	 * @param {Object} config.group_data all the groups data
	 * @param {Array} config.groups_available all the groups the user can access (only set in LA)
	 * @param {Bool} config.display_facets are we displaying facet limiters
	 * @param {Object} config.facets facet limiters for current search
	 * @param {Object} config.sort sorting for current search
	 * @param {Object[]} config.sort_options options for sorting the results
	 * @param {String} config.sort_options[].field name of sorting field
	 * @param {String} config.sort_options[].dir direction of sort (asc/desc)
	 * @param {String} config.sort_options[].label human readable name of sorting field
	 * @param {Object} [config.query_facet_results] facets data returned for current search
	 * @param {Object} config.searchwt weight for various search fields
	 */
	setConfig: function(config) {
		var defaults = {
			iid: 0,
			isDefaultGroup: true,
			group_id_default: [],
			groups_available: [],
			group_data: {},
			display_facets: true,
			facets: {
				topics: [],
				keywords: [],
				g: []
			},
			sort: { field: '_score', dir: 'desc' },
			sort_options: [
				{ field: '_score', dir: 'desc', label: this.get('lang').srch_sortlabelrel },
				{ field: 'updated', dir: 'desc', label: this.get('lang').srch_sortlabeldatedesc },
				//{ field: 'updated', dir: 'asc', label: this.get('lang').srch_sortlabeldateasc }
			],
			query_facet_results: {},
			facet_results: {},
			searchwt: { question: '6', details: '3', topics: '4', keywords: '5', allInOne: '1' }
		};

		_.extend(defaults, config);
		_.each(defaults, function(v,k,l){
			this.set(k, v, { silent: true });
		}, this);


		//if groups_available is still [] then add all public group_data to it
		if (this.get('groups_available').length === 0) {
			var ga = [];
			_.each(this.get('group_data'), function(v,k){
				ga.push(v.id);
			}, this);
			this.set('groups_available', ga);
		}

		if (this.get('group_id_default').length === 0) {
			this.set('group_id_default', this.get('groups_available'));
		}

		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });

		if (this.get('group_id_default').length === 1) {
			this.setLAFacet({ facet: 'g', value: this.get('group_id_default')[0] });
		}

		//Listen for facets set form the controller's query string
		this.listenTo(searchcontroller, "facet:set", this.setLAFacet);
	},
	/**
	 * Set a facet without initiating a query or overwriting other facets
	 * used to set facets from query string by controller
	 * @param {Object} d data
	 * @param {String} d.facet name of facet
	 * @param {String} d.value value of facet to set
	 */
	setLAFacet: function(d) {
		if (d.facet && d.facet !== '' && d.value && d.value !== '') {
			//make sure we are only setting LA facets.
			if ( this.get('facets')[d.facet] ) {
				this.setFacet(d.facet, d.value, false, false);
			}
		}
	},
	/**
	 * Render the views
	 */
	renderViews: function() {
		var $container = jQuery(this.get('selector'));
		var views = []; //array of rows with views in them

		var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });
		var params = new LACurrentParamsView({ model: this, id: 's-srch-params-'+this.get('id') });
		var resultslist = new LAResultsList({ model: this, id: 's-srch-results-'+this.get('id') });
		var askform = new AskView({ model: this, formType: 'noresults', alert_text: this.get('lang').srch_notasked, source: this.get('id') });

		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}

		views.push( jQuery('<div class="row"></div>').append([searchheader.$el, top_pagination.$el]) );
		if (searchcontroller.get('layout') !== 'bento') {
			views.push( jQuery('<div class="row"></div>').append(params.$el) );
		}
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );
		views.push( jQuery('<div class="row"></div>').append(askform.$el) );

		if (this.get('display_facets') === true) {
			var $col1 = jQuery('<div class="col-md-9"></div>').append(views);
			var $col2 = jQuery('<div class="col-md-3"></div>');

			//facet views
			var facetviews = [];
			_.each(this.get('facets'), function(v,k,l){
				facetviews.push( new LAFacetView({ model: this, id: 's-srch-facet-'+this.get('id')+'-'+k, facetType: k }) );
			}, this);
			_.each(facetviews, function(v,k){
				$col2.append(v.$el);
			}, this);
			$container.append( jQuery('<div class="row"></div>').append($col1, $col2) );
		} else {
			$container.append( views );
		}
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		if (typeof autocomp == 'undefined') {
			autocomp = false;
		}

		qo = {
			search_source_id: this.get('id'),
			rows: this.get('perpage'),
			iid: this.get('iid'),
			searchwt: JSON.stringify(this.get('searchwt'))
		};

		//facets
		var facets = this.get('facets');

		//build the group params
		if (facets.g && facets.g.length > 0) {
			var group_ids = [];
			_.each(facets.g, function(v){
				if (this.get('groups_available').indexOf(v) == -1) { return; } //keep people from searching groups they shouldn't
				group_ids.push(v);
			}, this);
			qo.group_ids = group_ids;
		} else if (this.get('group_id_default').length > 0) {
			qo.group_ids = this.get('group_id_default');
		} else {
			qo.group_ids = this.get('groups_available');
		}
		qo.group_ids = JSON.stringify(qo.group_ids);

		var page = this.get('page');
		qo.start = (qo.rows * (page - 1));

		//we skip some stuff for autocomplete
		if (!autocomp) {
			_.each(facets, function(v,k,l){
				if (k == 'g') { return; }
				var facetquery = '';
				if (v.length > 0) {
					qo[k] = JSON.stringify(v);
				}
			}, this);

			qo.q = this.convertSearch();

			var s = this.get('sort');
			qo.sort = s.field+' '+s.dir;

			this.set('query_obj', qo);
		} else {
			qo.facet = false;
			return qo;
		}
	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * override in subclass
	 */
	convertSearch: function() {
		//maybe we need to escape (with a backslash \ ) some characters: + - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
		var typed = this.get('query_typed');
		return typed;
	},
	/**
	 * Request the data (an ajax request)
	 */
	requestData: function() {
		var self = this;

		workingAlert();

		$.ajax({
		  url: this.protocol+'//'+this.get('request_url'),
		  data: this.get('query_obj'),
		  success: function(d, status){
		  	  clearTimeout(requestError);
 			  self.cacheResults(d);
			  self.parseResults(d);
			  self.setFocus();
			  stopAlert();
		  },
		  dataType: 'jsonp',
		});

		var requestError = setTimeout(function() {
		   // Handle error accordingly
		   errorAlert();
		}, 10000);

		//record query spy if available
		if (typeof springSpace.querySpy !== 'undefined') {
			try {
				var q = this.get('query_typed');
				if (q == '' || q == '*:*') { return; }
				springSpace.querySpy.record({ query: q });
			} catch(e) {
				searchcontroller.debug(e);
			}
		}
	},
	/**
	 * Update the facets only for query string or group change.
	 * Facets are returned based on query string and group only.
	 */
	retrieveFacets: function() {
		qo = {
			search_source_id: this.get('id'),
			rows: 0,
			iid: this.get('iid'),
			searchwt: JSON.stringify(this.get('searchwt'))
		};

		//facets
		var facets = this.get('facets');

		if (facets.g.length > 0) {
			var group_ids = [];
			_.each(facets.g, function(v,k,l){
				group_ids.push(v);
			}, this);
			qo.group_ids = group_ids;
		} else {
			var g_avail = this.get('groups_available');
			if (g_avail.length == 1) {
				qo.group_ids = [g_avail[0]];
			} else if (this.get('group_id_default').length > 0) {
				qo.group_ids = this.get('group_id_default');
			} else {
				qo.group_ids = g_avail;
			}
		}
		qo.group_ids = JSON.stringify(qo.group_ids);

		qo.q = this.convertSearch();

		if (this.facetCache[jQuery.param(qo, true)]) {
			this.parseFacets(this.facetCache[jQuery.param(qo, true)]);
			return;
		}

		var self = this;

		$.ajax({
		  url: this.protocol+'//'+this.get('request_url'),
		  data: qo,
		  success: function(d, status){
		  	  //clearTimeout(requestError);
 			  self.cacheFacets(jQuery.param(qo, true), d);
			  self.parseFacets(d);
		  },
		  dataType: 'jsonp',
		});
	},
	/**
	 * Apply facet data retrieved from Solr
	 */
	parseFacets: function(data) {
		this.set('facet_results', data.facets);
		this.trigger('facets:retrieve');
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from solr query
	 */
	parseResults: function(data) {
		this.set({
			'results': data.results,
			'total_results': data.total_results,
			'query_facet_results': data.facets
		});
		if (data.total_results == 0) {
			this.trigger('search:noresults');
		} else {
			this.trigger('search:retrieve');
		}
		if (this.get('display_facets')) {
			this.retrieveFacets();
		}
	}

});


//!LAResultsList View
var LAResultsList = ResultsList.extend(
/** @lends ResultsList.prototype */
{

	events: {
		'click .s-srch-result-subj a': 'setFacet',
		'click .s-srch-result-title a': 'gotoAnswer',
		'contextmenu .s-srch-result-title a': 'gotoAnswer',
	},
	/**
	 * render the results
	 */
    render: function () {
    	var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
		var results = this.model.get('results');
		if(results.length > 0) {
			_.each(results, function(v){
				$list.append(this.resultItem(v));
			}, this);
		}
		this.$el.html($list);

		try {
        	if (window.self !== window.top) {
	        	//in iframe add target to FAQ links
	        	$('.s-la-faq-listing-q a').attr('target', '_parent');
        	}
		} catch (e) { }

		return this;
    },
    /**
     * When no results are retrieved empty results list. No results alert/form will appear.
     */
    noResults: function() {
    	$(this.el).html('');
    	return this;
    },
	/**
	 * Show the result
	 * @param {Object} item result object
	 * @param {Int} item.group_id group id
	 * @param {Int} item.faqid faq id
	 * @param {Array} item.keywords_text the keywords
	 * @param {Array} item.topics_text topic names only
	 * @param {String} item.question
	 * @param {String} item.updated last updated date
	 * @param {Int} item.s LA iid
	 * @return {Object} jQuery object
	 */
	resultItem: function(item) {
		var $li = $('<li></li>').addClass('s-srch-result');
		var html = '';

		if (!item.faqid || !item.group_id || !item.question) { return ''; }

		var domain = ( this.model.get('site_url') == '' ? '/' : '//' + this.model.get('site_url') );

		var qurl = (this.model.get('group_data')[item.group_id].slug == '') ? 'faq/'+item.faqid : this.model.get('group_data')[item.group_id].slug+'/faq/'+item.faqid;

		item.url = ( domain == '/' ? domain : domain + '/' ) + qurl;
		if (!item.updated_formatted) {
			var date = new Date(item.updated);
			item.updated_formatted = date.format(this.model.get('lang').Dt_DateTime);
		}
		item.topics_text = (item.topics_text) ? item.topics_text : [];

		if (this.model.get('item_template') === '') {
			if (searchcontroller.get('layout') == 'bento') {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-faqid={{faqid}}>{{question}}</a>'+
				'</div>'+
				'<div class="s-srch-result-meta">'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (topics_text.length > 0) { }}'+
						'<span class="divider">|</span><span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_topic+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_topic+'">'+
								'{{# _.each(topics_text, function(v,k){ }}'+
									'<li>{{v}}'+
									'{{# if (k+1 < topics_text.length){ print(\';\'); } }}'+
									'</li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			} else {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-faqid={{faqid}}>{{question}}</a>'+
				'</div>'+
				'<div class="s-srch-result-meta">'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (topics_text.length > 0) { }}'+
						'<span class="divider">|</span><span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_topic+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_topic+'">'+
								'{{# _.each(topics_text, function(v){ }}'+
									'<li><span class="label label-default"><a href="#" data-topic="{{{v}}}">{{v}}</a></span></li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			}
		}

		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}

		try {
			html = this.item_template(item);
		} catch(e) {
			//Error
			searchcontroller.debug(e);
			return '';
		}
		return $li.html( html );
	},
	/**
	 * Clicking on a result title updates query spy
	 */
	gotoAnswer: function(e) {
		var faqid = $(e.currentTarget).attr('data-faqid');
		if (!!faqid) {
			if (typeof springSpace.querySpy !== 'undefined') {
				try {
					var q = this.model.get('query_typed');
					if (q == '' || q == '*:*') { return; }
					springSpace.querySpy.gotoFAQ({ faqid: faqid });
				} catch(e) {
					searchcontroller.debug(e);
				}
			}
		} else {
			searchcontroller.debug('no faqid');
		}
		return true;
	},
	/**
	 * Clicking on a topic in the results sets that topic as the only facet filter
	 */
	setFacet: function(e) {
		e.preventDefault();
		var topic = $(e.currentTarget).attr('data-topic');
		this.model.setFacet('topics', topic);
	}

});

//!LACurrentParamsView
var LACurrentParamsView = CurrentParamsView.extend(
/** @lends LACurrentParamsView.prototype */
{
	/**
	 * create the display
	 */
	render: function() {

		this.$el.html('');
		var $container = jQuery('<div></div>').addClass('s-srch-params').attr({ 'aria-live': 'polite', 'aria-relevant': 'text' });

		var facetData = this.model.get('facets');

		var links = [];
		//iterate the facet types
		_.each(facetData, function(f, t){
			if (f.length > 0) {
				//iterate the values on the specific facet
				$li = $('<li></li>');
				if (t == 'g') {
					//show nothing if they only have one group available
					if (this.model.get('groups_available').length == 1) {
						return;
					}
					//dont show full default list
					if (this.model.get('isDefaultGroup') === true && compareArrays(this.model.get('group_id_default'), f)) {
						$li.append('<span>'+this.model.get('lang')['srch_filters_g']+':</span> All');
						links.push($li);
						return;
					}
				}

				$li.append('<span>'+this.model.get('lang')['srch_filters_'+t]+':</span> ');
				var html = ' ';
				_.each(f, function(v,k,l) {
					var f_value = (t == 'g') ? this.model.get('group_data')[v].name : v;
					html += '"'+f_value+'"';
					if (l.length > (k + 1)) {
			    	 	html += ' OR ';
		    	    }
				}, this);

				if (f.length > 1) {
					html = '('+html+')';
				}
				var $filterNames = $('<span></span>').text(html);
        		$li.append($filterNames);
				links.push($li);
			}
		}, this);

		//add a remove all link if appropriate
		if (links.length > 0) {
			$li = $('<li></li>').append(
		    	        $('<a href="#" class="removeAll" aria-controls="s-srch-results-'+this.model.get('id')+'"></a>')
		    	        .html('<i class="fa fa-times-circle"></i> '+this.model.get('lang').srch_facetremoveall)
		    	    );
			links.push($li);
		}

		if (links.length > 0) {
			this.$list = $('<ul class="list-inline"></ul>');

			_.each(links, function(v){
				this.$list.append(v);
			}, this);

			$container.append(['<h3>'+this.model.get('lang').srch_filtercurr+'</h3>', this.$list]);
			this.$el.append($container).removeClass('hidden');
		} else {
			this.$el.addClass('hidden');
		}
		return this;
	}

});


//!LAFacetView
var LAFacetView = FacetView.extend(
/** @lends LAFacetView.prototype */
{

	/**
	 * create the display
	 */
	render: function() {
		searchcontroller.debug('LAFacetView render');
		searchcontroller.debug(this.facetType);
		switch(this.facetType) {
			case 'g':
				this.makeLabel = function(v) {  return this.model.get('group_data')[v].name; }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf( v.toString() ) > -1) }
				break;
			default:
				this.makeLabel = function(name) {
					return name;
					//return name.capitalize();
				}
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
		}
		this.header = this.model.get('lang')['srch_filters_'+this.facetType];

		this.$el.html('');
		this.$el.append('<h3><button class="btn btn-default s-srch-facet-btn" type=button data-toggle="collapse" data-target="#s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"><span class="s-srch-side-collapse"><i class="fa fa-caret-down"></i></span> '+this.header+'</button></h3>');

		this.$list = $('<ul class="s-srch-cloud list-unstyled collapse in" id="s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"></ul>');
		this.$el.append(this.$list);

		return this;
	},

	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		this.$list.empty();

		var facetData = this.model.get('facet_results');
		var curFacets = this.model.get('facets')[this.facetType];
		var list = [];

		// for groups facet show all groups all the time.
		if (this.facetType === 'g') {
			_.each(this.model.get('groups_available'), function(v){
				var checked = this.facetSelected(v);
				var $li = $('<li></li>');
				var $label = $('<label class="check"></label>');
				var $input = $('<input type="checkbox" />').attr('name', v).prop('checked', checked).attr('aria-controls', 's-srch-results-'+this.model.get('id'));

				var cur = _.find(facetData[this.facetType], function(f) { return f.value == v; });
				var count = (cur && cur.count) ? ' ('+cur.count+')' : '';
				$label.append([$input, ' '+this.makeLabel(v)+count]);
				$li.append($label);

				list.push($li);
			}, this);
		} else {

			if (facetData[this.facetType] && facetData[this.facetType].length > 0) {
				_.each(facetData[this.facetType], function(v) {
					var checked = this.facetSelected(v.value);
					var $li = $('<li></li>');
					var $label = $('<label class="check"></label>');
					var $input = $('<input type="checkbox" />').attr('name', v.value).prop('checked', checked).attr('aria-controls', 's-srch-results-'+this.model.get('id'));

					$label.append($input).append(' '+this.makeLabel(v.value)+' (' + v.count +')');
					$li.append($label);

					list.push($li);
				}, this);
			}
		}

		if (list.length == 0) {
			this.$list.append('<li>'+this.model.get('lang').srch_facetnone+'</li>');
		} else {
			_.each(list, function(v){
				this.$list.append(v);
			}, this);
		}
	},

});
;
/**
 * SearchLG, subclass of SearchInterface
 * requires backbone.js
 */

var SearchLG = SearchInterface.extend({
	/** @lends SearchLG.prototype */


	/**
	 * Set the interface's config options
	 * @param {Object} config
	 * @param {Number} config.site_id system id
	 * @param {Number} config.guide_id guide id for the guide where the search originated (for stats purposes?)
	 * @param {Array} config.group_data group data
	 * @param {Object} config.searchwt weight for various search fields,
	 * @param {Bool} config.display_facets do we show facets or not
	 * @param {String} config.profile_url url for linking to profiles
	 */
	setConfig: function(config) {
		var defaults = {
			site_id: 0,
			guide_id: 0,
			group_data: [],
			display_facets: true,
			facets: {
				group:[],
				tag:[],
				guide_type:[],
				subject:[]
			},
			sort: { field: 'score', dir: 'desc' },
			sort_options: [
				{ field: 'score', dir: 'desc', label: this.get('lang').srch_sortlabelrel },
				{ field: 'updated', dir: 'desc', label: this.get('lang').srch_sortlabeldatedesc },
			],
			query_facet_results: {},
			searchwt: { guide: 6, page: 5, subject: 4, tag: 4, allInOne: 1 },
			profile_url: ''
		};

		_.extend(defaults, config);
		_.each(defaults, function(v,k,l){
			this.set(k, v, { silent: true });
		}, this);

		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });

		//Listen for facets set form the controller's query string
		this.listenTo(searchcontroller, "facet:set", this.setLGFacet);
	},
	/**
	 * Set a facet without initiating a query or overwriting other facets
	 * used to set facets from query string by controller
	 * @param {Object} d data
	 * @param {String} d.facet name of facet
	 * @param {String} d.value value of facet to set
	 */
	setLGFacet: function(d) {
		if (d.facet && d.facet !== '' && d.value && d.value !== '') {
			//make sure we are only setting LG facets.
			if ( this.get('facets')[d.facet] ) {
				this.setFacet(d.facet, d.value, false, false);
			}
		}
	},
	/**
	 * Render the views
	 */
	renderViews: function() {
		var $container = jQuery(this.get('selector'));
		var views = []; //array of rows with views in them

		var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });
		var params = new LGCurrentParamsView({ model: this, id: 's-srch-params-'+this.get('id') });
		var resultslist = new LGResultsList({ model: this, id: 's-srch-results-'+this.get('id') });
		//var askform = new AskView({ model: this, formType: 'noresults', alert_text: this.get('lang').srch_notasked, source: this.get('id') });

		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}

		views.push( jQuery('<div class="row"></div>').append([searchheader.$el, top_pagination.$el]) );
		if (searchcontroller.get('layout') !== 'bento') {
			views.push( jQuery('<div class="row"></div>').append(params.$el) );
		}
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );
		//views.push( jQuery('<div class="row"></div>').append(askform.$el) );

		if (this.get('display_facets') === true) {
			var $col1 = jQuery('<div class="col-md-9 col-left"></div>').append(views);
			var $col2 = jQuery('<div class="col-md-3 col-right"></div>');

			//facet views
			var facetviews = [];
			_.each(this.get('facets'), function(v,k,l){
				facetviews.push( new LGFacetView({ model: this, id: 's-srch-facet-'+this.get('id')+'-'+k, facetType: k }) );
			}, this);
			_.each(facetviews, function(v,k){
				$col2.append(v.$el);
			}, this);
			$container.append( jQuery('<div class="row"></div>').append($col1, $col2) );
		} else {
			$container.append( views );
		}
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		if (typeof autocomp == 'undefined') {
			autocomp = false;
		}

		qo = {
			search_source_id: this.get('id'),
			rows: this.get('perpage'),
			'facet.limit': 20,
			'group.limit': 4
		};

		//facets
		facets = this.get('facets');

		//site param
		qo['fq'] = [];
		qo['fq'].push('s:'+this.get('site_id'));

		var page = this.get('page');
		qo.start = (qo.rows * (page - 1));

		//we skip some stuff for autocomplete
		if (!autocomp) {
			_.each(facets, function(v,k,l){
				var facetquery = '';
				if (v.length > 0) {
					_.each(v, function(vx,kx,lx){
						facetquery += '"'+vx+'"';
						if (kx !== lx.length - 1) {
							facetquery += ' OR ';
						}
					}, this);
					qo['fq'].push(k+':('+facetquery+')');
				}

			}, this);

			qo.q = this.convertSearch();

			s = this.get('sort');
			qo.sort = s.field+' '+s.dir;

			this.set('query_obj', qo)
		} else {
			qo.facet = false;
			return qo;
		}

	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * override in subclass
	 */
	convertSearch: function() {
		//maybe we need to escape (with a backslash \ ) some characters: + - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
		var typed = this.get('query_typed');
		//if (typed == '') { return '*:*'; }

		//typed = typed.replace(/([\(\)\[\]\{\}\^~:\\\/])/ig, '\\$1');
		return typed;
	},
	/**
	 * Request the data (an ajax request)
	 */
	requestData: function() {
		// if the request was coming from a LG2 site, call the local search function which returns fully rendered HTML
		if (typeof searchLg2Local !== 'undefined') {
			searchLg2Local(this.get('id'));
		}
		// else, the request is coming from another app (LA) so we make the API based search call which returns JSON formatted data
		else {
			var self = this;

			workingAlert();

			$.ajax({
			  url: this.protocol+'//'+this.get('request_url'),
			  data: this.get('query_obj'),
			  success: function(d, status){
				  clearTimeout(requestError);
				  self.cacheResults(d);
				  self.parseResults(d);
				  self.setFocus();
				  stopAlert();
			  },
			  traditional: true, //this lets the query have multiple parameters that don't use the [] syntax (cause solr wants that)
			  dataType: 'jsonp',
			  jsonp: 'json.wrf'
			});

			var requestError = setTimeout(function() {
			   // Handle error accordingly
			   errorAlert();
			}, 10000);
		}

        //track stats in LG
		if (typeof springSpace.springTrack !== 'undefined') {
			try {
				if (facets.group && facets.group.length > 0) {
					group_id = (typeof this.get('group_data')[facets.group[0]] !== 'undefined') ? this.get('group_data')[facets.group[0]].id : 0;
				} else {
                    group_id = 0;
                }

				if (this.get('query_typed') == '' || this.get('query_typed') == '*:*') { return; }

				springSpace.springTrack.trackSearch({ _st_type_id: '13', _st_group_id: group_id, _st_guide_id: this.get('guide_id'), _st_search_terms: this.get('query_typed') });
			} catch(e) {
				searchcontroller.debug(e);
			}
		}

	},
	/**
	 * Not doing this for LG
	 */
	retrieveFacets: function() {
		return;
	},
	/**
	 * Apply facet data retrieved from search
	 */
	parseFacets: function(data) {
		// only run for API based searches; local LG searches will process facets in searchLg2Local()
		if (typeof searchLg2Local == 'undefined') {
			this.set('facet_results', data.facet_counts.facet_fields);
			this.trigger('facets:retrieve');
		}
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from solr query
	 */
	parseResults: function(data) {
		this.set('results', data.grouped.g.groups);
		this.set('total_results', data.grouped.g.ngroups);
		this.set('query_facet_results', data.facet_counts.facet_fields);
		if (data.grouped.g.ngroups == 0) {
			this.trigger('search:noresults');
		} else {
			this.trigger('search:retrieve');
		}

		if (this.get('display_facets')) {
			// we only want to do this if the query string changes....
			if (this.facetCache[this.get('query_typed')]) {
				this.parseFacets(this.facetCache[this.get('query_typed')]);
			} else {
				this.cacheFacets(this.get('query_typed'), data);
				this.parseFacets(data);
			}
		}
	}

});


//!LGResultsList View
var LGResultsList = ResultsList.extend(
/** @lends LGResultsList.prototype */
{

	events: {
		'click .s-srch-result-subj a': 'setFacet',
	},
	/**
	 * render the results
	 */
    render: function () {
    	var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
		var results = this.model.get('results');
		if(results.length > 0) {
			_.each(results, function(v,k,l){
				$list.append(this.resultItem(v));
			}, this);
		}
		this.$el.html($list);

		return this;
    },
    /**
     * When no results are retrieved empty results list. No results alert/form will appear.
     */
    noResults: function() {
    	$(this.el).html('');
    	return this;
    },
	/**
	 * Show the result
	 * @param {Object} result result object containing the grouped result data:
	 * @param {Array} result.doclist.docs is an array of page item
	 	item.doclist.docs.g: guide_id
	 	item.doclist.docs.p: page_id
	 	item.doclist.docs.guide: guide title
	 	item.doclist.docs.gd: guide description
	 	item.doclist.docs.subjects: array of subjects names
	 	item.doclist.docs.updated: last update Date
	 	item.doclist.docs.s: site_id
	 	item.doclist.docs.an: author (lastcommafirst)
	 	item.doclist.docs.aid: author id ???
	 	item.doclist.docs.slug: friendly url
	 	item.doclist.docs.pslug: page friendly url
	 * @return {Object} jQuery object
	 */
	resultItem: function(result) {
		var $li = $('<li></li>').addClass('s-srch-result');
		var html = '';

		var pages = result.doclist.docs;
        // Allow relative and absolute URLs.
		var domain = ( this.model.get('site_url') == '' ? '/' : '//' + this.model.get('site_url') );
		var item = result.doclist.docs[0]; //use first page result to get guide data
		if (!item.g) { item.g = ''; }
		if (!item.guide) { item.guide = ''; }
		if (!item.gd) { item.gd = ''; }
		if (!item.aid) { item.aid = ''; }

		var qurl = ( domain == '/' ? domain : domain + '/' );
		if (item.slug && item.slug !== '') {
			qurl += item.slug;
		} else {
			qurl += 'c.php?g='+item.g;
		}
		item.url = qurl;

		if (!item.updated_formatted) {
			var date = new Date(item.updated);
			item.updated_formatted = date.format(this.model.get('lang').Dt_DateTime);
		}

		item.pages = [];
		_.each(pages, function(v,k,l){
            var purl = ( domain == '/' ? domain : domain + '/' );
			if (v.pslug && v.pslug !== '') {
				purl += v.pslug;
			} else if (v.slug && v.slug !== '') {
				purl += v.slug+'?p='+v.p;
			} else {
				purl += 'c.php?g='+v.g+'&p='+v.p;
			}
			item.pages.push({ url: purl, title: v.page });
		}, this);

		item.profile_url = this.model.get('profile_url')+item.aid;
		item.an = (item.an) ? item.an.replace(',', ', ') : '';
		if (typeof item.subject == 'undefined') { item.subject = []; }

		if (this.model.get('item_template') === '') {
			if (searchcontroller.get('layout') == 'bento') {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-guide_id={{g}}>{{guide}}</a>'+
				'</div>'+
				'{{# if (gd !== "") { }}<p class=s-srch-result-desc">{{gd}}</p>{{# } }}'+
				'<div class="s-srch-result-meta">'+
					'<span class="s-srch-result-author"><span class=metalabel>'+this.model.get('lang').srch_by+'</span><a href="{{profile_url}}">{{an}}</a></span><span class="divider">|</span>'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (subject.length > 0) { }}'+
						'<span class="divider">|</span>'+
						'<span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
								'{{# _.each(subject, function(v,k){ }}'+
									'<li>{{v}}'+
									'{{# if (k+1 < subject.length){ print(\';\'); } }}'+
									'</li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			} else {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-guide_id={{g}}>{{guide}}</a>'+
				'</div>'+
				'{{# if (gd !== "") { }}<p class=s-srch-result-desc">{{gd}}</p>{{# } }}'+
				'<div class="s-srch-result-meta">'+
					'{{# if (pages.length > 0) { }}'+
						'<ul class="s-srch-result-pages">'+
							'{{# _.each(pages, function(v){ }}'+
								'<li><a href="{{v.url}}">{{v.title}}</a></li>'+
							'{{# }); }}'+
						'</ul>'+
					'{{# } }}'+
					'<span class="s-srch-result-author"><span class=metalabel>'+this.model.get('lang').srch_by+'</span><a href="{{profile_url}}">{{an}}</a></span><span class="divider">|</span>'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (subject.length > 0) { }}'+
						'<span class="divider">|</span>'+
						'<span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
								'{{# _.each(subject, function(v){ }}'+
									'<li><span class="label label-default"><a href="#" data-subject="{{{v}}}">{{v}}</a></span></li>'+
									//'<li><a href="#" data-subject="{{{v}}}">{{v}}</a>;</li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			}
		}

		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}

		try {
			html = this.item_template(item);
		} catch(e) {
			searchcontroller.debug(e);
			return '';
		}
		return $li.html( html );
	},

	/**
	 * Clicking on a result title... does nothing right now, but it could do stats
	 */
	gotoAnswer: function(e) {
		return true;
	},
	/**
	 * Clicking on a topic in the results sets that topic as the only facet filter
	 */
	setFacet: function(e) {
		e.preventDefault();
		var subject = $(e.currentTarget).attr('data-subject').toLowerCase();
		this.model.setFacet('subject', subject);
	}

});


//!LGCurrentParamsView
var LGCurrentParamsView = CurrentParamsView.extend(
/** @lends LGCurrentParamsView.prototype */
{
	/**
	 * create the display
	 */
	render: function() {
		this.$el.html('');
		var $container = jQuery('<div></div>').addClass('s-srch-params').attr({ 'aria-live': 'polite', 'aria-relevant': 'text' });

		var facetData = this.model.get('facets');

		var links = [];
		//iterate the facet types
		_.each(facetData, function(f, t){
			if (f.length > 0) {
				//iterate the values on the specific facet
				$li = jQuery('<li></li>');
				$li.append('<span>'+this.model.get('lang')['srch_filters_'+t]+':</span> ');
				var html = ' ';
				_.each(f, function(v,k,l) {
					var f_value = v;
					html += '"'+f_value+'"';
					if (l.length > (k + 1)) {
			    	 	html += ' OR ';
		    	    }
				}, this);

				if (f.length > 1) {
					html = '('+html+')';
				}
				var $filterNames = $('<span></span>').text(html);
        		$li.append($filterNames);
				links.push($li);
			}
		}, this);

		//add a remove all link if appropriate
		if (links.length > 0) {
			$li = jQuery('<li></li>').append(
		    	        jQuery('<a href="#" class="removeAll" aria-controls="s-srch-results-'+this.model.get('id')+'"></a>')
		    	        .html('<i class="fa fa-times-circle"></i> '+this.model.get('lang').srch_facetremoveall)
		    	    );
			links.push($li);
		}

		if (links.length > 0) {
			this.$list = $('<ul class="list-inline"></ul>');
			_.each(links, function(v){
				this.$list.append(v);
			}, this);

			$container.append(['<h3>'+this.model.get('lang').srch_filtercurr+'</h3>', this.$list]);
			this.$el.append($container).removeClass('hidden');
		} else {
			this.$el.addClass('hidden');
		}
		return this;
	}
});


//!LGFacetView
var LGFacetView = FacetView.extend(
/** @lends LGFacetView.prototype */
{

	/**
	 * create the display
	 */
	render: function() {
		searchcontroller.debug('LGFacetView render');
		searchcontroller.debug(this.facetType);
		switch(this.facetType) {
			case 'group':

				this.makeLabel = function(name) {
					return (typeof this.model.get('group_data')[name] !== 'undefined') ? this.model.get('group_data')[name].name : name;
				}
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
			case 'guide_type':
				this.makeLabel = function(name) { return name.capitalize(); }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
			case 'subject':
				this.makeLabel = function(name) { return name.capitalize(); }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
			case 'tag':
				this.makeLabel = function(name) { return name.capitalize(); }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
				break;
		}
		this.header = this.model.get('lang')['srch_filters_'+this.facetType];

		this.$el.html('');
		this.$el.append('<h3><button class="btn btn-default s-srch-facet-btn" type=button data-toggle="collapse" data-target="#s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"><span class="s-srch-side-collapse"><i class="fa fa-caret-down"></i></span> '+this.header+'</button></h3>');

		this.$list = $('<ul class="s-srch-cloud list-unstyled collapse in" id="s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"></ul>');
		this.$el.append(this.$list);

		return this;
	},

	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		this.$list.empty();

		var facetData = this.model.get('facet_results');
		var curFacets = this.model.get('facets')[this.facetType];
		var list = [];
		if (facetData) {
			_.each(facetData[this.facetType], function(v,k,l) {
				var checked = this.facetSelected(k);
				var $li = jQuery('<li></li>');
				var $label = jQuery('<label class="check"></label>');
				var $input = jQuery('<input type="checkbox" />').attr('name', k).prop('checked', checked).attr('aria-controls', 's-srch-results-'+this.model.get('id'));

				$label.append($input).append(' '+this.makeLabel(k)+' (' + v +')');
				$li.append($label);

				list.push($li);
			}, this);
		}
		if (list.length == 0) {
			this.$list.append('<li>'+this.model.get('lang').srch_facetnone+'</li>');
		} else {
			_.each(list, function(v){
				this.$list.append(v);
			}, this);
		}
	},

});
;
/**
 * SearchAZ, subclass of SearchInterface
 * requires backbone.js
 */

var SearchAZ = SearchInterface.extend({
	/** @lends SearchAZ.prototype */

	/**
	 * Set the interface's config options
	 * @param {Object} config
	 * @param {Int} config.site_id LG site id
	 * @param {Bool} config.display_facets are we displaying facet limiters
	 * @param {Object} config.facets facet limiters for current search
	 * @param {Object} config.sort sorting for current search
	 * @param {Object[]} config.sort_options options for sorting the results
	 * @param {String} config.sort_options[].field name of sorting field
	 * @param {String} config.sort_options[].dir direction of sort (asc/desc)
	 * @param {String} config.sort_options[].label human readable name of sorting field
	 * @param {Object} [config.query_facet_results] facets data returned for current search
	 * @param {Object} config.searchwt weight for various search fields
	 * @param {String} config.alphaLetter Single letter to browse source names
	 */
	setConfig: function(config) {
		var defaults = {
			site_id: 0,
			display_facets: true,
			facets: {
				subjects: [],
				types: [],
				vendor: [],
				_n: []
			},
			perpage: 50,
			sort: { field: 'n', dir: 'asc' },
			sort_options: [
				//{ field: 'score', dir: 'desc', label: this.get('lang').srch_sortlabelrel },
				//{ field: 'n', dir: 'asc', label: this.get('lang').srch_sortlabelalpha }
			],
			query_facet_results: {},
			searchwt: { subjects: 8, n: 8, d: 3, best_bets: 9, allInOne: 1 },
			alphaLetter: ''
		};

		_.extend(defaults, config);
		_.each(defaults, function(v,k,l){
			this.set(k, v, { silent: true });
		}, this);

		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });
	},
	/**
	 * Render the views
	 */
	renderViews: function() {
		var $container = jQuery(this.get('selector'));
		var views = []; //array of rows with views in them

		//var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		var params = new AZCurrentParamsView({ model: this, id: 's-srch-params-'+this.get('id') });

		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });

		var resultslist = new AZResultsList({ model: this, id: 's-srch-results-'+this.get('id') });

		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}

		views.push( jQuery('<div class="row"></div>').append(['<div class="col-sm-6"></div>', top_pagination.$el]) );
		views.push( jQuery('<div class="row"></div>').append(params.$el) );
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );

		if (this.get('display_facets') === true) {
			// lg2 local searching
			if (typeof searchLg2Az !== 'undefined') {
				var $col1 = jQuery('<div class="col-md-9 col-left"></div>').append(views);
				var $col2 = jQuery('<div class="col-md-3 col-right"></div>');
				$container.append( jQuery('<div class="row"></div>').append([$col1, $col2]) );
			}
			// api (la) searching
			else {
				var $col1 = jQuery('<div class="col-md-12"></div>').append(views);
				var $col2 = jQuery('<div class="col-md-12"></div>');

				//facet views
				var facetviews = [];
				_.each(this.get('facets'), function(v,k,l){
					if (k == '_n') {
						facetviews.push( new AZBrowseView({ model: this, facetType: k }) );
					} else {
						facetviews.push( new AZFacetView({ model: this, id: 's-srch-facet-'+this.get('id')+'-'+k, facetType: k }) );
					}
				}, this);
				_.each(facetviews, function(v,k){
					$col2.append(v.$el);
				}, this);
				$container.append( jQuery('<div class="row"></div>').append([$col2, $col1]) );
			}
		} else {
			$container.append( views );
		}
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		if (typeof autocomp == 'undefined') {
			autocomp = false;
		}

		qo = {
			search_source_id: this.get('id'),
			rows: this.get('perpage'),
		};

		//facets
		var facets = {};
		facets = this.get('facets');
		qo['facet.limit'] = 100;

		//site param
		qo['fq'] = [];
		qo['fq'].push('s:'+this.get('site_id'));

		var page = this.get('page');
		qo.start = (qo.rows * (page - 1));

		//we skip some stuff for autocomplete
		if (!autocomp) {
			_.each(facets, function(v,k,l){
				var facet_query = '';
				var facetquery = '';
				if (k == '_n') {
					if (v.length > 0) {
						if (v[0] == '#') {
							qo['fq'].push('-_n:/[a-z]/i');
						} else {
							qo['fq'].push('_n:'+v[0]);
						}
					}
				}

				else if (v.length > 0) {
					_.each(v, function(vx,kx,lx){
						facetquery += '"'+vx+'"';
						if (kx !== lx.length - 1) {
							facetquery += ' OR ';
						}
					}, this);
					facet_query = k+':('+facetquery+')';
					qo['fq'].push(facet_query);
				}

			}, this);

			qo.q = this.convertSearch();
			//user alpha for browse and relevancy for search
			if (qo.q == '*:*') {
				this.set('sort', { field: 'n', dir: 'asc' });
			} else {
				this.set('sort', { field: 'score', dir: 'desc' });
			}

			s = this.get('sort');
			qo.sort = s.field+' '+s.dir;

			this.set('query_obj', qo);
		} else {
			qo.facet = false;
			return qo;
		}

	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * @return {string}
	 */
	convertSearch: function() {
		//maybe we need to escape (with a backslash \ ) some characters: + - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
		var typed = this.get('query_typed');
		return typed;
	},
	/**
	 * Request the data (an ajax request)
	 * Fires a bunch of events on success
	 * return {null}
	 */
	requestData: function() {
		// if the request was coming from a LG2 site, call the local search function which returns fully rendered HTML
		if (typeof searchLg2Az !== 'undefined') {
			searchLg2Az(this.get('id'));
		}
		// else, the request is coming from another app (LA) so we make the API based search call which returns JSON formatted data
		else {
			var self = this;

			workingAlert();

			$.ajax({
			  url: this.protocol+'//'+this.get('request_url'),
			  data: this.get('query_obj'),
			  success: function(d, status){
				  clearTimeout(requestError);
				  self.cacheResults(d);
				  self.parseResults(d);
				  self.setFocus();
				  stopAlert();
			  },
			  traditional: true, //this lets the query have multiple parameters that don't use the [] syntax (cause solr wants that)
			  dataType: 'jsonp',
			  jsonp: 'json.wrf'
			});

			var requestError = setTimeout(function() {
			   // Handle error accordingly
			   errorAlert();
			}, 10000);
		}

        //track stats in LG; TODO replace the hardcoded 27 with a reference to StatsConst::TRACKING_TYPE_SEARCH_AZ?
		if (typeof springSpace.springTrack !== 'undefined') {
			try {
				if (this.get('query_typed') == '' || this.get('query_typed') == '*:*') { return; }
				springSpace.springTrack.trackSearch({ _st_type_id: '27', _st_group_id: 0, _st_guide_id: 0, _st_search_terms: this.get('query_typed') });
			}
			catch(e) {
				searchcontroller.debug(e);
			}
		}

	},
	/**
	 * Apply facet data retrieved from Solr
	 */
	parseFacets: function(data) {
		// only run for API based searches; local LG searches will process facets in searchLg2Local()
		if (typeof searchLg2Az !== 'undefined') {
			return;
		}
		searchcontroller.debug(this.get('id')+' parseFacets');

		//integrate best_bets into subjects
		if (data.facet_counts.facet_fields && data.facet_counts.facet_fields.best_bets) {
			var best_bets = data.facet_counts.facet_fields.best_bets;
			delete data.facet_counts.facet_fields.best_bets;
			if (!data.facet_counts.facet_fields.subjects) {
				data.facet_counts.facet_fields.subjects = {};
			}

			_.each(best_bets, function(v,k){
				if (data.facet_counts.facet_fields.subjects[k]) {
					data.facet_counts.facet_fields.subjects[k] = data.facet_counts.facet_fields.subjects[k] + v;
				} else {
					data.facet_counts.facet_fields.subjects[k] = v;
				}
			}, this);
		}

		//convert _n to first letter
		if (data.facet_counts.facet_fields && data.facet_counts.facet_fields._n) {
			var names = data.facet_counts.facet_fields._n;
			data.facet_counts.facet_fields._n = {};
			_.each(names, function(v,k){
				//var letter = k.substr(0, 1);
				if (!data.facet_counts.facet_fields._n[k]) {
					if (k.match(/[a-z]/i) == null) {
						k = '#';
					}
					data.facet_counts.facet_fields._n[k] = 1;
				}
			}, this);
		}

		this.set('facet_results', data.facet_counts.facet_fields);
		this.trigger('facets:retrieve');
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from solr query
	 */
	parseResults: function(data) {
		this.set({
			'results': data.response.docs,
			'total_results': data.response.numFound,
			'query_facet_results': data.facet_counts.facet_fields
		});

		if (this.get('display_facets')) {
			//this.retrieveFacets(); //Use the facets from the results set directly
			this.parseFacets(data);
		}

		if (data.response.numFound == 0) {
			this.trigger('search:noresults');
		} else {
			this.trigger('search:retrieve');
		}

	}

});


//!AZResultsList View
var AZResultsList = ResultsList.extend(
/** @lends AZResultsList.prototype */
{

	events: {
		'click .s-srch-showqform': 'showQForm',
		'click .s-srch-result-subj a': 'setFacet',
		'click .s-srch-result-title a': 'trackClick',
	},
	/**
	 * render the results
	 */
    render: function () {
	    var subject_facet = this.model.get('facets')['subjects'];
	    this.cur_subj = (subject_facet.length > 0) ? subject_facet[0].toLowerCase() : '';

    	var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
    	var $features_list = $('<ul class="list-unstyled"></ul>');
		var results = this.model.get('results');
		var include_featured = false;
		if(results.length > 0) {
			_.each(results, function(v,k,l){
				var $li = this.resultItem(v);
				if ($li.hasClass('s-srch-result-featured')) {
					$features_list.append($li);
					include_featured = true;
				} else {
					$list.append($li);
				}
			}, this);
		}

		if (include_featured) {
			$list.prepend( $('<li></li>').addClass('s-srch-results-featured').append([$('<h3></h3>').html( this.model.get('lang').az_bestbets_heading ), $features_list]) );
		}

		this.$el.html($list);
		return this;
    },
	/**
     * When no results are retrieved empty results list. No results alert/form will appear.
     */
    noResults: function() {
    	$(this.el).html('');
    	return this;
    },
	/**
	 * Show the result
	 * @param {Object} item result object
	 * @param {Int} item.g group id
	 * @param {Int} item.id faq id
	 * @param {Array} item.keywords the keywords
	 * @param {Array} item.topics topic names only
	 * @param {String} item.question
	 * @param {String} item.updated last updated date
	 * @param {Int} item.s LA iid
	 * @return {Object} jQuery object
	 */
	resultItem: function(item) {
		var $li = $('<li></li>').addClass('s-srch-result');

		if (!item.id) { return ''; }

		item.subjects = (item.subjects) ? item.subjects : [];

        // If the site_url is zero-length consider it a relative URL.
		item.url = ( this.model.get('site_url') == '' ? '/' : '//' + this.model.get('site_url') + '/' ) + 'go.php?c='+item.id;

		/*
		id type="integer" -> ID
		s type="integer" -> SITE ID
		n type="u_text" -> Name
		_n type = ??? -> First Letter of Name
		d type="text" -> Description
		m type="text" -> more info currently empty???
		types type="u_text"
		subjects type="u_text"
		best_bets type="u_text"
		created type="date" ->
		updated type="date" ->
		owner type="u_text"
		vendor type="u_text" ->
		slug type="u_text"
		trial type="boolean" -> trial flag
		new" type="boolean" -> new flag
		*/

		if (!item.n) { item.n = ''; }
		if (!item.d) { item.d = ''; }

		//Figure out if it's a "best bet" for the current subject
		item.isbest = false;
		if (this.cur_subj !== '' && item.best_bets && item.best_bets.length > 0 && Array.prototype.some) {
			var index = -1;
			item.best_bets.some(function(element, i) {
			    if (this.cur_subj === element.toLowerCase()) {
			        index = i;
			        return true;
			    }
			}, this);
			if (index !== -1) {
				item.isbest = true;
			}
		}
		if (item.isbest) {
			$li.addClass('s-srch-result-featured');
		}


		//add best bets to subject array
		if (item.best_bets && item.best_bets.length > 0) {
			item.subjects = _.union(item.best_bets, item.subjects);
		}

		item.isnew = item['new'];

		if (this.model.get('item_template') === '') {
			if (searchcontroller.get('layout') == 'bento') {
				this.model.set('item_template',
					'<div class=s-srch-result-title>'+
						'<a href="{{ url }}" data-id={{ id }}>{{ n }}</a>'+
						'{{# if (isbest) { }} <span class="badge-featurd label label-success">'+this.model.get('lang').az_bestbets_label+'</span>{{# } }}'+
						'{{# if (isnew) { }} <span class="badge-new label label-info">'+this.model.get('lang').az_new_label+'</span>{{# } }}'+
						'{{# if (trial) { }} <span class="badge-trial label label-warning">'+this.model.get('lang').az_trial_label+'</span>{{# } }}'+
					'</div>'+
					'<div class="s-srch-result-meta">'+
						'{{# if (d !== \'\') { }}<p>{{ d }}</p>{{# } }}'+
						'{{# if (subjects.length > 0) { }}'+
							'<span class="s-srch-result-subj">'+
								'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
								'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
									'{{# _.each(subjects, function(v,k){ }}'+
									'<li>{{v}}'+
									'{{# if (k+1 < subjects.length){ print(\';\'); } }}'+
									'</li>'+
								'{{# }); }}'+
								'</ul>'+
							'</span>'+
						'{{# } }}'+
					'</div>'
					,
				{ silent: true });
			} else {
				this.model.set('item_template',
					'<div class=s-srch-result-title>'+
						'<a href="{{ url }}" data-id={{ id }}>{{ n }}</a>'+
						'{{# if (isbest) { }} <span class="badge-featurd label label-success">'+this.model.get('lang').az_bestbets_label+'</span>{{# } }}'+
						'{{# if (isnew) { }} <span class="badge-new label label-info">'+this.model.get('lang').az_new_label+'</span>{{# } }}'+
						'{{# if (trial) { }} <span class="badge-trial label label-warning">'+this.model.get('lang').az_trial_label+'</span>{{# } }}'+
					'</div>'+
					'<div class="s-srch-result-meta">'+
						'{{# if (d !== \'\') { }}<p>{{ d }}</p>{{# } }}'+
						'{{# if (subjects.length > 0) { }}'+
							'<span class="s-srch-result-subj">'+
								'<span class=metalabel>'+this.model.get('lang').srch_subject+'</span>'+
								'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_subject+'">'+
									'{{# _.each(subjects, function(v){ }}'+
										'<li><span class="label label-default"><a href="#" data-subject="{{{ v }}}">{{ v }}</a></span></li>'+
									'{{# }); }}'+
								'</ul>'+
							'</span>'+
						'{{# } }}'+
					'</div>'
					,
				{ silent: true });

			}
		}

		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}

		try {
			html = this.item_template(item);
		} catch(e) {
			searchcontroller.debug(e);
			return '';
		}
		return $li.html( html );
	},
	/**
	 * Clicking on a result title updates stats
	 */
	trackClick: function(e) {
		if (typeof springTrack !== 'undefined') {
			var id = jQuery(e.currentTarget).attr('data-id');
			try {
				springTrack.trackLink({ link: e.currentTarget, _st_type_id: '16', _st_content_id: id });
			} catch(e) {
				searchcontroller.debug(e);
			}
		}
		return true;
	},
	/**
	 * Clicking on a subjects in the results sets that subjects as the only facet filter
	 */
	setFacet: function(e) {
		e.preventDefault();
		var subject = $(e.currentTarget).attr('data-subject').toLowerCase();
		this.model.setFacet('subjects', subject);
	}
});

//!AZCurrentParamsView
var AZCurrentParamsView = CurrentParamsView.extend(
/** @lends AZCurrentParamsView.prototype */
{
	/**
	 * create the display
	 */
	render: function() {

		this.$el.html('');
		var $container = jQuery('<div></div>').addClass('s-srch-params s-srch-params-az').attr({ 'aria-live': 'polite', 'aria-relevant': 'text' });

		var facetData = this.model.get('facets');

		var links = [];

		//So we dont show the current search and clear button on bento
		if (searchcontroller.get('layout') !== 'bento') {
			//iterate the facet types
			_.each(facetData, function(f, t){
				if (f.length > 0) {
					//iterate the values on the specific facet
					$li = $('<li></li>');
					var html = ' ';
					_.each(f, function(v,k,l) {
						var f_value = v.capitalize();
						if (f_value.indexOf(' ') !== -1) {
							html += '"'+f_value+'"';
						} else {
							html += f_value;
						}

						if (l.length > (k + 1)) {
				    	 	html += ' OR ';
			    	    }
					}, this);

					if (f.length > 1) {
						html = '('+html+')';
					}
					html += ';'

					var $filterNames = $('<span></span>').text(html);
        			$li.append($filterNames);

					links.push($li);
				}
			}, this);

			if (this.model.get('query_typed') !== '') {
				$li = $('<li></li>');
				var $span = $('<span></span>').text(' ' + this.model.get('query_typed') + ';');
				$li.append($span);
				links.push($li);
			}
		}

		//add a remove all link if appropriate
		if (links.length > 0) {
			$li = $('<li></li>').append(
		    	        $('<a href="#" class="removeAll" aria-controls="s-srch-results-'+this.model.get('id')+'"></a>')
		    	        .html('<i class="fa fa-times-circle"></i> '+this.model.get('lang').az_clear_filters)
		    	    );
			links.push($li);
		}

		var total = this.model.get('total_results');
		var perPage = this.model.get('perpage');
		var offset = (this.model.get('page') - 1) * perPage;

		this.$rangeHeader = $('<span></span>').text(springSpace.Util.stringFormat(this.model.get('lang').srch_resrange, [Math.min(total, offset + 1) + ' - ' + Math.min(total, offset + perPage), total]) + ' '+this.model.get('lang').az_database_plural);

		if (links.length > 0) {
			this.$rangeHeader.text(this.$rangeHeader.text()+': ');

			this.$list = $('<ul class="list-inline"></ul>');

			_.each(links, function(v){
				this.$list.append(v);
			}, this);
			$container.append([ this.$rangeHeader, this.$list ]);
		} else {
			$container.append( this.$rangeHeader );
		}
		this.$el.append($container).removeClass('hidden');
		return this;
	},
	/**
	 * remove all limiters (including query)
	 * @param {Object} e click event object
	 */
	removeAll: function(e) {
		e.preventDefault();
		this.model.removeAllFacets(true);
	}

});


//!AZFacetView
var AZFacetView = FacetView.extend(
/** @lends AZFacetView.prototype */
{

	/**
	 * Different events for this facet type
	 */
	events: {
		'change select': 'toggleFacet'
	},
	initialize: function(options) {
		if (options.facetType) {
			this.facetType = options.facetType;
		}
		this.listenTo(this.model, 'search:retrieve search:noresults', this.makeList);
		this.render();
	},
	/**
	 * create the display
	 */
	render: function() {
		this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }

		this.$el.html('');

		var $label = jQuery('<label></label>').addClass('sr-only').attr('for', 's-srch-'+this.model.get('id')+'-facet-'+this.facetType).html( this.model.get('lang')['az_dropdown_'+this.facetType] );

		this.$select = jQuery('<select></select>').attr({
			'id': 's-srch-'+this.model.get('id')+'-facet-'+this.facetType,
			'class': 'form-control',
			'name': this.facetType,
			'aria-controls': 's-srch-results-'+this.model.get('id')
		});

		var $div = jQuery('<div></div>').addClass('col-sm-4 form-group').append([$label, this.$select]);

		this.$el.append($div);

		return this;
	},
	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		this.$select.empty();

		var facetData = this.model.get('facet_results');
		var curFacets = this.model.get('facets')[this.facetType];
		var list = [];

		list.push($('<option></option>').text(this.model.get('lang')['srch_filters_az_'+this.facetType]).attr('value', ''));

		//new array so we can sort the facets alphabetically
		var facet_names = _.keys(facetData[this.facetType]).sort();
		_.each(facet_names, function(v,k) {

			var checked = (this.facetSelected(v)) ? 'selected' : '';
			var $option = $('<option></option>').text(v.capitalize()).attr('value', v).prop('selected', checked);
			list.push($option);
		}, this);

		if (list.length == 0) {
			this.$select.append('<option>'+this.model.get('lang').srch_facetnone+'</option>');
		} else {
			_.each(list, function(v){
				this.$select.append(v);
			}, this);
		}
	},
	/**
	 * Apply facet via select change event
	 */
	toggleFacet: function(e) {
		if ($(e.currentTarget).val() == '') {
			this.model.removeFacet(this.facetType);
		} else {
			this.model.setFacet(this.facetType, $(e.currentTarget).val(), false);
		}
	},

});


//!AZBrowseView
var AZBrowseView = Backbone.View.extend(
/** @lends AZBrowseView.prototype */
{

	/**
	 * Different events for this facet type
	 */
	events: {
		'click a[data-letter]': 'browseAlpha'
	},

	initialize: function(options) {
		if (options.facetType) {
			this.facetType = options.facetType;
		}
		this.render();
		this.listenTo(this.model, 'search:retrieve search:noresults', this.updateLetter);
		this.listenTo(this.model, 'search:retrieve search:noresults', this.updateLinks);
	},
	/**
	 * create the display
	 */
	render: function() {

		this.$el.html('');

		var $label = jQuery('<h3></h3>').addClass('sr-only').attr('id', 's-srch-'+this.model.get('id')+'-facet-'+this.facetType).html( this.model.get('lang')['az_browse_name'] );

		this.$list = jQuery('<ol></ol>').attr({
			'class': 'list-unstyled list-inline',
			'aria-labelledby': 's-srch-'+this.model.get('id')+'-facet-'+this.facetType
		});

		var links = [
			$('<li></li>').append( $('<a></a>').html( this.model.get('lang').az_filter_all ).attr({ href: '#', 'data-letter': '', 'aria-controls': 's-srch-results-'+this.model.get('id') }) )
		];

		var alphabet = "abcdefghijklmnopqrstuvwxyz#".split("");
		_.each(alphabet, function(letter) {

			  links.push( $('<li></li>').append( $('<a></a>').html(letter.toUpperCase()).attr({ href: '#', 'data-letter': letter, 'aria-controls': 's-srch-results-'+this.model.get('id') }) ) )

		}, this);

		this.$list.append(links);

		var $div = jQuery('<div></div>').addClass('col-sm-12 s-srch-alphabrowse').attr('id', 's-srch-'+this.model.get('id')+'-alphabrowse').append([$label, this.$list]);

		this.$el.append($div);

		return this;
	},
	/**
	 * Update the currently selected (bolded) letter
	 */
	updateLetter: function() {
		var curLetter = this.model.get('alphaLetter');
		this.$list.find('a').removeClass('current');
		this.$list.find('a[data-letter="'+curLetter+'"]').addClass('current');
	},
	/**
	 * Update the inactive letters for current results
	 */
	updateLinks: function() {
		searchcontroller.debug('updateLinks');
		var facetData = this.model.get('facet_results')._n;

		this.$list.find('a').each(function(i,el){
			var $link = $(el);
			$link.removeClass('inactive');
			var linkletter = $link.attr('data-letter');
			if (linkletter !== '' && facetData && !facetData[linkletter]) {
				$link.addClass('inactive');
			}

		});

	},
	/**
	 * Browse by letter
	 * @param {Object} e event object for click
	 */
	browseAlpha: function(e) {
		e.preventDefault();
		var $link = $(e.currentTarget);
		if ($link.hasClass('inactive')) { return; }
		var letter = $link.attr('data-letter');

		if (letter == '') {
			this.model.removeFacet('_n');
			return;
		}

		this.model.setFacet('_n', letter, false);
	},

});
